// import React, { useState, useEffect, useRef } from 'react';
// import { Edit, Trash2, Plus, Search, X, Download, MapPin, FileText, Edit2, Send, Eye, Loader2, Globe, Filter, Briefcase, ChevronDown, ChevronUp } from 'lucide-react';
// import { useLanguage } from '../StoreContext/LanguageContext';
// import DownloadModal from '../Components/Download/DownloadModal';
// import apiService from '../config';
// import Parishtisht1Notice from "./Parishtisht1Notice";
// import Parishtisht6Notice from "./Parishtisht6Notice";
// import AddLandholdingList from "./AddLandholdingList";
// import EditLandholdingList from "./EditLandholdinglist";
// import { useSignature } from '../DigitalSignature/UseSignatue';
// import SignaturePad from '../DigitalSignature/SignaturePad';
// import SendTrackingModal from '../CommonModel/SendTrackingModal';
// import EditProposal from "./EditProposal";

// const LandholdingList = ({ onBack, setSelectedComponent, onNavigateWithModal, setSubComponent, shouldRestoreModal, modalParams, setShouldRestoreModal }) => {
//     const { language, translations } = useLanguage();
//     const formRef = useRef(null);
//     const listRef = useRef(null);
    
//     // Core Data States
//     const [landholdingData, setLandholdingData] = useState([]);
//     const [selectedLandId, setSelectedLandId] = useState(null);
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState(null);
//     const [searchTerm, setSearchTerm] = useState('');
//     const [downloadModalOpen, setDownloadModalOpen] = useState(false);
//     const [downloadLoading, setDownloadLoading] = useState(false);
    
//     // Project & Proposal States
//     const [currentProjectId, setCurrentProjectId] = useState(null);
//     const [selectedProject, setSelectedProject] = useState(() => {
//         try {
//             const project = localStorage.getItem("selectedProject");
//             return project ? JSON.parse(project) : null;
//         } catch (error) {
//             console.error("Error parsing project data:", error);
//             return null;
//         }
//     });
//     const [proposalId, setProposalId] = useState(null);
//     const [proposalLocations, setProposalLocations] = useState([]);
    
//     // UI & Form States
//     const [isViewerOpen, setIsViewerOpen] = useState(false);
//     const [viewerFile, setViewerFile] = useState(null);
//     const [editProposalMode, setEditProposalMode] = useState(false);
//     const [showAddForm, setShowAddForm] = useState(false);
//     const [showEditForm, setShowEditForm] = useState(false);
//     const [editingLandholding, setEditingLandholding] = useState(null);
//     const [activeAddFormIndex, setActiveAddFormIndex] = useState(null);
//     const [expandedRow, setExpandedRow] = useState(null);
//     const [filterMode, setFilterMode] = useState('all');

//     // Modal & Tracking States
//     const [showAlertModal, setShowAlertModal] = useState(false);
//     const [alertConfig, setAlertConfig] = useState({ title: '', message: '', type: 'success' });
//     const [showConfirmModal, setShowConfirmModal] = useState(false);
//     const [confirmConfig, setConfirmConfig] = useState({ title: '', message: '', onConfirm: null, onCancel: null, type: 'warning' });
//     const [showSendToCollectorModal, setShowSendToCollectorModal] = useState(false);
//     const [showBackToProjectInchargeModal, setShowBackToProjectInchargeModal] = useState(false);
//     const [showBackToSamanvayModal, setShowBackToSamanvayModal] = useState(false);
//     const [showModal, setShowModal] = useState(false); // Document preview modal

//     // Users & Roles
//     const [users, setUsers] = useState([]);
//     const [laoUsers, setLaoUsers] = useState([]);
//     const [selectedUser, setSelectedUser] = useState('');
//     const [selectedLao, setSelectedLao] = useState('');
//     const [assignLAO, setAssignLAO] = useState('');
//     const [sendToRole, setSendToRole] = useState('LAO');
//     const [loadingUsers, setLoadingUsers] = useState(false);
//     const [buttonDisabled, setButtonDisabled] = useState(false);

//     // Tracking Senders
//     const [trackingSenderName, setTrackingSenderName] = useState('');
//     const [trackingSenderUserId, setTrackingSenderUserId] = useState('');
//     const [samanvaySenderName, setSamanvaySenderName] = useState('');
//     const [samanvaySenderUserId, setSamanvaySenderUserId] = useState('');
    
//     // Actions & Document Upload
//     const [remarks, setRemarks] = useState('Approved');
//     const [selectedDocument, setSelectedDocument] = useState(null);
//     const [documentUrl, setDocumentUrl] = useState('');
//     const [sendingToSamanvay, setSendingToSamanvay] = useState(false);
//     const [sendingToCollector, setSendingToCollector] = useState(false);
//     const [sendingToLAO, setSendingToLAO] = useState(false);
//     const [showProgress, setShowProgress] = useState(false);
//     const [uploadProgress, setUploadProgress] = useState(0);
//     const [successMessage, setSuccessMessage] = useState('');
//     const [showSuccess, setShowSuccess] = useState(false);
    
//     // Digital Signature
//     const { uploadStatus, uploadError, selectedSignDocument, signDocument } = useSignature();
//     const [showSignaturePad, setShowSignaturePad] = useState(false);
//     const [pdfForSigning, setPdfForSigning] = useState(null);
//     const [isSignedPdfAvailable, setIsSignedPdfAvailable] = useState(false);

//     const ROLES = {
//         PROJECT_INCHARGE: 18,
//         SAMANVAY: 6,
//         COLLECTOR: 1,
//         LAO: 3,
//         DATA_ENTRY: 14
//     };

//     const pendingRestore = useRef(null);

//     const [userRole, setUserRole] = useState(() => {
//         try {
//             const userData = localStorage.getItem("userData");
//             if (userData) {
//                 const user = JSON.parse(userData);
//                 return user.user_role || user.usr_role || null;
//             }
//         } catch (error) {
//             console.error("Error parsing user data:", error);
//         }
//         return null;
//     });

//     const showAlert = (title, message, type = 'info') => {
//         setAlertConfig({ title, message, type });
//         setShowAlertModal(true);
//         setTimeout(() => setShowAlertModal(false), 5000);
//     };

//     const showConfirm = (title, message, onConfirm, onCancel = null, type = 'warning') => {
//         setConfirmConfig({ title, message, onConfirm, onCancel, type });
//         setShowConfirmModal(true);
//     };

//     useEffect(() => {
//         const getProjectInfo = () => {
//             const selectedProject = localStorage.getItem('selectedProject');
//             if (selectedProject) {
//                 try {
//                     const project = JSON.parse(selectedProject);
//                     return { id: project.project_id || project.id, name: project.project_name || project.name };
//                 } catch (e) {
//                     console.error('Error parsing selected project:', e);
//                 }
//             }

//             const userData = localStorage.getItem('userData');
//             if (userData) {
//                 try {
//                     const user = JSON.parse(userData);
//                     return { id: user.data?.project_id || user.project_id, name: user.data?.project_name || user.project_name || 'Unknown Project' };
//                 } catch (e) {
//                     console.error('Error parsing user data:', e);
//                 }
//             }
//             return { id: null, name: null };
//         };

//         const projectInfo = getProjectInfo();
//         setCurrentProjectId(projectInfo.id);

//         const savedProposalId = localStorage.getItem('currentProposalId');
//         if (savedProposalId) setProposalId(savedProposalId);
//     }, []);

//     useEffect(() => {
//         if (currentProjectId && proposalId) {
//             checkSignedPdfAvailability();
//             fetchAssignLAO();
//             fetchUsersSamanvay();
//             fetchUsersCollector();
//             fetchButtonStatus();
//             fetchLandholdingData();
//         }
//     }, [currentProjectId, proposalId, userRole]);

//     useEffect(() => {
//         const loadLocationData = async () => {
//             try {
//                 const proposalStr = localStorage.getItem('selectedProposal');
//                 if (proposalStr) {
//                     const proposal = JSON.parse(proposalStr);
//                     let response;
                    
//                     if (proposal?.PROPOSAL_ID) {
//                         response = await apiService.get(`/getProposal?proposalId=${proposal.PROPOSAL_ID}`);
//                     } else if (proposal?.acquisition_proposal_id) {
//                         response = await apiService.get(`/getProposal?proposalId=${proposal.acquisition_proposal_id}`);
//                     }

//                     if (response?.data) {
//                         if (response.data.dtv && Array.isArray(response.data.dtv) && response.data.dtv.length > 0) {
//                             setProposalLocations(response.data.dtv);
//                         } else {
//                             setProposalLocations([{
//                                 dist_name: response.data.dist_name || proposal.dist_name,
//                                 taluka_name: response.data.taluka_name || proposal.taluka_name,
//                                 village_name: response.data.village_name || proposal.village_name
//                             }]);
//                         }
//                     }
//                 }
//             } catch (error) {
//                 console.error('Error loading default location data:', error);
//             }
//         };

//         if (currentProjectId) loadLocationData();
//     }, [currentProjectId]);

//     const checkSignedPdfAvailability = async () => {
//         try {
//             const res = await apiService.getSectionFile(currentProjectId, proposalId, "CoveringLettersSection11");
//             setIsSignedPdfAvailable(res?.isSignAvailable && res?.data?.[0]?.file_path);
//         } catch (error) {
//             console.error("Error checking signed pdf:", error);
//             setIsSignedPdfAvailable(false);
//         }
//     };

//     const fetchLandholdingData = async () => {
//         try {
//             setLoading(true);
//             setError(null);
//             if (!currentProjectId || !proposalId) return;

//             const result = await apiService.getLandHolding(currentProjectId, { proposalId });

//             if (result.status === 200 && result.data) {
//                 const transformedData = result.data.map(item => ({
//                     groupNo: item.LandAcquisition_id,
//                     landholdersName: item.landholder_name || '',
//                     DistrictName: item.dist_name,
//                     TalukaName: item.taluka_name,
//                     VillageName: item.village_name || 'Unknown Village',
//                     SurveyNO: item.survey_no || '',
//                     irrigableArea: parseFloat(item.irrigable_area) || 0,
//                     nonIrrigableArea: parseFloat(item.non_irrigable_area) || 0,
//                     totalArea: parseFloat(item.total_area) || 0,
//                     AquiredArea: parseFloat(item.aqr_area) || 0,
//                     unit_name: item.unit_name || '',
//                     status: item.is_active,
//                     owners: item.owners || [],
//                 }));
//                 setLandholdingData(transformedData);
//             } else {
//                 setLandholdingData([]);
//             }
//         } catch (err) {
//             console.error('Error fetching landholding data:', err);
//             setError(err.message);
//             setLandholdingData([]);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const fetchButtonStatus = async () => {
//         try {
//             setLoading(true);
//             let response;
//             switch (userRole) {
//                 case ROLES.PROJECT_INCHARGE: response = await apiService.getSamanvayButton(currentProjectId, proposalId); break;
//                 case ROLES.SAMANVAY: response = await apiService.getCollectorButton(currentProjectId, proposalId); break;
//                 case ROLES.COLLECTOR: response = await apiService.getLAOButton(currentProjectId, proposalId); break;
//                 default: return;
//             }
//             const isDisabled = !response?.buttonDisable;
//             setButtonDisabled(isDisabled);
//             localStorage.setItem('sentToSamanvay', isDisabled ? 'true' : 'false');
//         } catch (error) {
//             console.error("Error fetching button state:", error);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const fetchUsersCollector = async () => {
//         setLoadingUsers(true);
//         try {
//             const response = await apiService.getAllUserCollector(1, currentProjectId, proposalId);
//             if (response.status === 200 && response.data) {
//                 setUsers(Array.isArray(response.data) ? response.data : []);
//                 if (response.data.length > 0) setSelectedUser(response.data[0].id || response.data[0].usr_id);
//             }
//         } catch (error) { setUsers([]); } finally { setLoadingUsers(false); }
//     };

//     const fetchAssignLAO = async () => {
//         setLoadingUsers(true);
//         try {
//             const response = await apiService.getAllAssignUserRoleLAO(3, currentProjectId, proposalId);
//             if (response.status === 200 && response.data) setAssignLAO(Array.isArray(response.data) ? response.data : []);
//         } catch (error) { setAssignLAO([]); } finally { setLoadingUsers(false); }
//     };

//     const fetchUsersSamanvay = async () => {
//         setLoadingUsers(true);
//         try {
//             const response = await apiService.getAllAssignUserRoleSamanvay(6, currentProjectId, proposalId);
//             if (response.status === 200 && response.data) setUsers(Array.isArray(response.data) ? response.data : []);
//         } catch (error) { setUsers([]); } finally { setLoadingUsers(false); }
//     };

//     const handleAssignLAO = async (laoUserId) => {
//         await apiService.getAllUserRoleLAO(3, currentProjectId, proposalId);
//     };

//     const getFinalDocument = () => selectedSignDocument || selectedDocument || null;

//     const handleSendToCollector = async (collectorUserId) => {
//         const finalDocument = getFinalDocument();
//         if (!finalDocument) return showAlert('Document Required', 'Please upload or sign a document');

//         setSendingToCollector(true);
//         setShowProgress(true);
//         setUploadProgress(0);

//         try {
//             const formData = new FormData();
//             formData.append('project_id', currentProjectId);
//             formData.append('proposal_id', proposalId);
//             formData.append('remarks', remarks);
//             formData.append('usr_id', collectorUserId);
//             formData.append('document', finalDocument);

//             const response = await apiService.postTrackingCollector(formData);
//             if (response.status === 200) {
//                 setUploadProgress(100);
//                 setTimeout(() => setShowSuccess(false), 5000);
//                 fetchButtonStatus();
//             }
//         } catch (error) {
//             showAlert('Failed to send to Collector. Please check your connection and try again.');
//         } finally {
//             setSendingToCollector(false);
//             setShowProgress(false);
//             setUploadProgress(0);
//         }
//     };

//     const handleSendToLAO = async () => {
//         const finalDocument = getFinalDocument();
//         const finalSelectedUser = selectedLao || (assignLAO?.length > 0 ? assignLAO[0].usr_id || assignLAO[0].id : null);

//         setSendingToLAO(true);
//         setShowProgress(true);
//         setUploadProgress(0);

//         try {
//             const formData = new FormData();
//             formData.append('project_id', currentProjectId);
//             formData.append('proposal_id', proposalId);
//             formData.append('remarks', remarks || 'Approved');
//             formData.append('usr_id', finalSelectedUser);
//             if (finalDocument) formData.append('document', finalDocument);

//             const response = await apiService.postTrackingLAO(formData);
//             if (response?.status === 200) {
//                 setUploadProgress(100);
//                 setShowSendToCollectorModal(false);
//                 setSelectedUser(''); setSelectedLao(''); setRemarks('Approved'); setSelectedDocument(null);
//                 fetchButtonStatus();
//             }
//         } catch (error) {
//             showAlert('Failed to appoint LAO Officer.');
//         } finally {
//             setSendingToLAO(false);
//             setShowProgress(false);
//             setUploadProgress(0);
//         }
//     };

//     const handleSendToSamanvay = async () => {
//         const finalDocument = getFinalDocument();
//         if (!finalDocument || !selectedUser) return showAlert('Required', 'Please select a user and upload a document');

//         setSendingToSamanvay(true);
//         setShowProgress(true);
//         setUploadProgress(0);

//         try {
//             const formData = new FormData();
//             formData.append('project_id', currentProjectId);
//             formData.append('proposal_id', proposalId);
//             formData.append('remarks', remarks);
//             formData.append('usr_id', selectedUser);
//             formData.append('document', finalDocument);

//             const response = await apiService.postTrackingSamanvay(formData);
//             if (response.status === 200) {
//                 setUploadProgress(100);
//                 setShowSendToCollectorModal(false);
//                 setSelectedUser(''); setRemarks('Approved'); setSelectedDocument(null);
//                 fetchButtonStatus();
//             }
//         } catch (error) {
//             showAlert('Failed to send to Samanvay Officer.');
//         } finally {
//             setSendingToSamanvay(false);
//             setShowProgress(false);
//             setUploadProgress(0);
//         }
//     };

//     const handleSendToSurveyor = async () => {
//         if (sendToRole === 'Samanvay') await handleSendToSamanvay();
//         else if (sendToRole === 'LAO') await handleSendToLAO();
//         else if (sendToRole === 'Collector') {
//             if (!selectedUser || !selectedDocument) return showAlert('Required', 'Please select Collector and upload a document');
//             try {
//                 setSendingToCollector(true);
//                 await handleAssignLAO(selectedLao);
//                 await handleSendToCollector(selectedUser);
//                 setShowSendToCollectorModal(false);
//                 setSelectedUser(''); setSelectedLao(''); setRemarks('Approved'); setSelectedDocument(null);
//                 fetchButtonStatus();
//             } catch (err) { showAlert("Something went wrong."); } finally { setSendingToCollector(false); }
//         }
//     };

//     const handleSendToLAOClick = async () => {
//         resetModalState(); setSendToRole('LAO');
//         if (buttonDisabled) return showConfirm('Confirm', 'You have already sent. Send again?', () => { setShowSendToCollectorModal(true); fetchAssignLAO(); });
//         setShowSendToCollectorModal(true);
//         await fetchAssignLAO();
//         setButtonDisabled(true);
//     };

//     const handleSendToSamanvayClick = () => {
//         resetModalState(); setSendToRole('Samanvay');
//         if (buttonDisabled) return showConfirm('Confirm', 'You have already sent. Send again?', () => { setShowSendToCollectorModal(true); fetchUsersSamanvay(); });
//         setShowSendToCollectorModal(true);
//         fetchUsersSamanvay();
//     };

//     const resetModalState = () => { setSelectedUser(''); setRemarks('Approved'); setSelectedDocument(null); setUsers([]); };

//     const handleAddNew = (loc, idx) => {
//         if (!currentProjectId || !proposalId) return showAlert('Project ID or Proposal ID missing!');
//         const info = { projectId: currentProjectId, proposalId: proposalId, district: loc?.dist_name || '', taluka: loc?.taluka_name || '', village: loc?.village_name || '' };
//         localStorage.setItem('selectedLocationInfo', JSON.stringify(info));
//         setActiveAddFormIndex(idx);
//         setEditingLandholding(null);
//     };

//     const handleEdit = (record) => {
//         localStorage.setItem('editingLandholding', JSON.stringify(record));
//         localStorage.setItem('selectedLocationInfo', JSON.stringify({ district: record.DistrictName || '', taluka: record.TalukaName || '', village: record.VillageName || '' }));
//         setSelectedLandId(record.groupNo);
//         setEditingLandholding(record);
//         setActiveAddFormIndex(null);
//     };

//     const handleDelete = async (record) => {
//         showConfirm(
//             'Delete Landholding', 
//             `Are you sure you want to delete landholding for ${record.landholdersName || 'this record'}?`, 
//             async () => {
//                 try {
//                     if (record.groupNo) {
//                         const response = await apiService.deleteLandHolding(record.groupNo);
//                         if (response.status !== 200) throw new Error('Failed to delete from server');
//                     }
                    
//                     setLandholdingData(prev => prev.filter((r) => String(r.groupNo) !== String(record.groupNo)));
//                     await fetchLandholdingData();
//                     showAlert('Success', 'Landholding deleted successfully!', 'success');
//                 } catch (err) { 
//                     console.error(err);
//                     showAlert('Error', 'Failed to delete landholding.', 'error'); 
//                 }
//             }, 
//             null, 
//             'danger'
//         );
//     };

//     const handleToggleStatus = async (record) => {
//         try {
//             const newStatus = !record.status;
//             if (record.groupNo) {
//                 const response = await apiService.updateLandHoldingStatus(record.groupNo, { is_active: newStatus });
//                 if (response.status !== 200) throw new Error('Failed to update status on server');
//             }
//             const updatedData = landholdingData.map(r => r.groupNo === record.groupNo ? { ...r, status: newStatus } : r);
//             setLandholdingData(updatedData);
//         } catch (err) {
//             console.error('Error updating status:', err);
//             showAlert('Failed to update status. Please try again.');
//         }
//     };

//     const handleViewDocument = (file) => {
//         if (!file) return;
//         setDocumentUrl(URL.createObjectURL(file)); 
//         setShowModal(true); 
//     };
    
//     const handleViewSignedPdf = async () => {
//         try {
//             const res = await apiService.getSectionFile(currentProjectId, proposalId, "CoveringLettersSection11");
//             if (res?.isSignAvailable && res?.data?.[0]?.file_path) { setViewerFile(res.data[0].file_path); setIsViewerOpen(true); }
//         } catch (error) { alert("Unable to open signed document"); }
//     };
//     const handleCoveringLetterClick = () => {
//         onNavigateWithModal('CoveringLetters', { selectedUser, userId: selectedLao, remarks, sendToRole, selectedDocumentName: selectedDocument?.name, timestamp: new Date().getTime() });
//         setShowSendToCollectorModal(false); setSubComponent(null);
//     };

//     useEffect(() => {
//         if (shouldRestoreModal && modalParams) {
//             setShowSendToCollectorModal(true); fetchUsersSamanvay();
//             pendingRestore.current = { user: modalParams.selectedUser || '', lao: modalParams.selectedLao || '', remarks: modalParams.remarks || '' };
//             setRemarks(modalParams.remarks || ''); setSendToRole(modalParams.sendToRole || 'Collector');
//             setShouldRestoreModal(false);
//         }
//     }, [shouldRestoreModal, modalParams]);

//     useEffect(() => {
//         if (pendingRestore.current && (users.length > 0 || laoUsers.length > 0)) {
//             setSelectedUser(pendingRestore.current.user); setSelectedLao(pendingRestore.current.lao); setRemarks(pendingRestore.current.remarks);
//             pendingRestore.current = null;
//         }
//     }, [users, laoUsers]);

//     // Component Handlers
//     const handleSearch = (e) => setSearchTerm(e.target.value);
//     const handleDownload = () => setDownloadModalOpen(true);
//     const handleReport = () => {
//         localStorage.setItem('selectedLocationInfo', JSON.stringify({ projectId: currentProjectId, district: '', taluka: '', village: '' }));
//         setSubComponent('ReportLandAcquisition');
//     };
    
//     const handleParishist = () => { setSelectedComponent("LandholdingList"); setSubComponent('Parishtisht1Notice'); };
//     const handleAnusuchi2 = () => { setSelectedComponent("LandholdingList"); setSubComponent('Anusuchi2'); };
//     const handleAnusuchi3 = () => { setSelectedComponent("LandholdingList"); setSubComponent('Anusuchi3'); };
//     const handleAnusuchi4 = () => { setSelectedComponent("LandholdingList"); setSubComponent('Anusuchi4'); };
//     const handleAnusuchi5 = () => { setSelectedComponent("LandholdingList"); setSubComponent('Anusuchi5'); };
//     const handleParishtisht6Notice = () => { setSelectedComponent("LandholdingList"); setSubComponent('Parishtisht6Notice'); };
//     const handleAnusuchi7 = () => { setSelectedComponent("LandholdingList"); setSubComponent('Anusuchi7'); };
//     const handleDocument = () => { setSelectedComponent("LandholdingList"); setSubComponent('OtherDocuments'); };
//     const handleAllDocument = () => { setSelectedComponent("LandholdingList"); setSubComponent('LandholdingAllDocu'); };
//     const handleProposalDocument = () => { setSelectedComponent("LandholdingList"); setSubComponent('ViewProposalDocument'); };
//     const handleEditProposalClick = () => setEditProposalMode(true);
//     const handleBackFromEditProposal = () => { setEditProposalMode(false); fetchLandholdingData(); };

//     // Download Logic
//     const getColumnsForDownload = () => [
//         { header: 'S.No.', value: 'index' }, { header: 'Land No', value: 'groupNo' }, { header: 'Landholders Name', value: 'landholdersName' },
//         { header: 'Village Name', value: 'VillageName' }, { header: 'Survey No', value: 'SurveyNO' }, { header: 'Total Area', value: 'totalArea' },
//         { header: 'Acquired Area', value: 'AquiredArea' }, { header: 'Area Unit', value: 'unit_name' }
//     ];
//     const getDataForDownload = () => filteredData.map((lh, index) => ({ ...lh, index: index + 1 }));

//     const filteredData = landholdingData.filter(record => {
//         const search = searchTerm.toLowerCase();
//         return String(record.groupNo || '').toLowerCase().includes(search) || String(record.landholdersName || '').toLowerCase().includes(search) ||
//             String(record.SurveyNO || '').toLowerCase().includes(search) || String(record.VillageName || '').toLowerCase().includes(search);
//     });

//     const shouldShowButton = (buttonName) => {
//         if (!userRole) return false;
//         const perms = { '15': ['appendix1', 'appendix2', 'appendix5', 'appendix6', 'appendix7'], '6': ['all'], '18': ['all'], '3': ['all'], '14': ['all'] };
//         return perms[String(userRole).trim()]?.includes('all') || perms[String(userRole).trim()]?.includes(buttonName.toLowerCase());
//     };

//     const ProgressBar = ({ progress, isVisible }) => isVisible && (
//         <div className="w-full bg-gray-200 rounded-full h-2 mb-4">
//             <div className="bg-blue-600 h-2 rounded-full transition-all duration-500 ease-out" style={{ width: `${progress}%` }} />
//             <div className="flex justify-between text-xs text-gray-500 mt-1"><span>{translations[language].saving}</span><span>{progress}%</span></div>
//         </div>
//     );

//     const toggleRow = (id) => setExpandedRow(expandedRow === id ? null : id);
//     const truncateName = (name, max = 15) => name?.length > max ? name.substring(0, max) + '...' : name || '';

//     if (editProposalMode && proposalId) {
//         return <EditProposal proposalId={proposalId} projectId={currentProjectId} projectName={selectedProject?.project_name} onBack={handleBackFromEditProposal} />;
//     }

//     return (
//         <div className="p-4">
//             {/* Top Action Buttons */}
//             <div className="mb-6 w-full">
//                 <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6 w-full">
//                     <div className="flex flex-wrap gap-3 flex-1">
//                         {(userRole !== ROLES.LAO && userRole !== ROLES.SAMANVAY && userRole !== ROLES.COLLECTOR) && shouldShowButton('appendix1') && (
//                             <button onClick={() => handleParishist()} disabled={landholdingData.length === 0} className="px-5 py-3 text-sm bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-xl flex items-center space-x-2 shadow-lg disabled:opacity-50">
//                                 <FileText className="h-5 w-5" /><span className="font-medium">{translations[language].appendix1}</span>
//                             </button>
//                         )}
//                         {(userRole !== ROLES.LAO && userRole !== ROLES.SAMANVAY && userRole !== ROLES.COLLECTOR) && shouldShowButton('appendix2') && (
//                             <button onClick={() => handleAnusuchi2()} disabled={landholdingData.length === 0} className="px-5 py-3 text-sm bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-xl flex items-center space-x-2 shadow-lg disabled:opacity-50">
//                                 <FileText className="h-5 w-5" /><span className="font-medium">{translations[language].appendix2}</span>
//                             </button>
//                         )}
//                         {(userRole !== ROLES.LAO && userRole !== ROLES.SAMANVAY && userRole !== ROLES.COLLECTOR) && shouldShowButton('appendix3') && (
//                             <button onClick={() => handleAnusuchi3()} disabled={landholdingData.length === 0} className="px-5 py-3 text-sm bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-xl flex items-center space-x-2 shadow-lg disabled:opacity-50">
//                                 <FileText className="h-5 w-5" /><span className="font-medium">{translations[language].appendix3}</span>
//                             </button>
//                         )}
//                         {userRole !== ROLES.LAO && shouldShowButton('appendix4') && (
//                             <button onClick={() => handleAnusuchi4()} disabled={landholdingData.length === 0} className="px-5 py-3 text-sm bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-xl flex items-center space-x-2 shadow-lg disabled:opacity-50">
//                                 <FileText className="h-5 w-5" /><span className="font-medium">{translations[language].Anusuchi4}</span>
//                             </button>
//                         )}
//                         {userRole !== ROLES.LAO && shouldShowButton('appendix5') && (
//                             <button onClick={() => handleAnusuchi5()} disabled={landholdingData.length === 0} className="px-5 py-3 text-sm bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-xl flex items-center space-x-2 shadow-lg disabled:opacity-50">
//                                 <FileText className="h-5 w-5" /><span className="font-medium">{translations[language].Anusuchi5}</span>
//                             </button>
//                         )}
//                         {(userRole !== ROLES.LAO && userRole !== ROLES.SAMANVAY && userRole !== ROLES.COLLECTOR) && shouldShowButton('appendix6') && (
//                             <button onClick={() => handleParishtisht6Notice()} disabled={landholdingData.length === 0} className="px-5 py-3 text-sm bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-xl flex items-center space-x-2 shadow-lg disabled:opacity-50">
//                                 <FileText className="h-5 w-5" /><span className="font-medium">{translations[language].appendix6}</span>
//                             </button>
//                         )}
//                         {userRole !== ROLES.LAO && shouldShowButton('appendix7') && (
//                             <button onClick={() => handleAnusuchi7()} disabled={landholdingData.length === 0} className="px-5 py-3 text-sm bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-xl flex items-center space-x-2 shadow-lg disabled:opacity-50">
//                                 <FileText className="h-5 w-5" /><span className="font-medium">{translations[language].Anusuchi7}</span>
//                             </button>
//                         )}
//                         {[ROLES.SAMANVAY, ROLES.COLLECTOR, ROLES.LAO].includes(userRole) && (
//                             <button onClick={() => handleProposalDocument()} disabled={landholdingData.length === 0} className="px-5 py-3 text-sm bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-xl flex items-center space-x-2 shadow-lg disabled:opacity-50">
//                                 <FileText className="h-5 w-5" /><span className="font-medium">{translations[language].AllDocuments}</span>
//                             </button>
//                         )}
//                         {[ROLES.SAMANVAY, ROLES.COLLECTOR].includes(userRole) && ['Collector', 'LAO'].includes(sendToRole) && (
//                             <button onClick={handleCoveringLetterClick} className="px-5 py-3 text-sm bg-blue-500 text-white rounded-xl shadow-lg">भूसंपादन अधिकारी नियुक्ती</button>
//                         )}
//                         {(userRole !== ROLES.LAO && userRole !== ROLES.SAMANVAY && userRole !== ROLES.COLLECTOR) && shouldShowButton('otherdocuments') && (
//                             <button onClick={() => handleDocument()} disabled={landholdingData.length === 0} className="px-5 py-3 text-sm bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-xl flex items-center space-x-2 shadow-lg disabled:opacity-50">
//                                 <FileText className="h-5 w-5" /><span className="font-medium">{translations[language].OtherDocuments}</span>
//                             </button>
//                         )}
//                         {(userRole !== ROLES.LAO && userRole !== ROLES.SAMANVAY && userRole !== ROLES.COLLECTOR) && (
//                             <button onClick={handleEditProposalClick} disabled={!proposalId || loading || buttonDisabled} className={`flex items-center gap-2 px-4 py-2 rounded-xl shadow-sm ${buttonDisabled ? 'bg-red-600 text-white' : 'bg-amber-600 text-white'}`}>
//                                 {loading ? <><Loader2 className="h-4 w-4 animate-spin" /><span>Processing...</span></> : <><Edit2 className="h-4 w-4" /><span>{translations[language].namunaK}</span></>}
//                             </button>
//                         )}
//                         {[ROLES.PROJECT_INCHARGE, ROLES.DATA_ENTRY].includes(userRole) && (
//                             <button onClick={() => handleAllDocument()} disabled={landholdingData.length === 0} className="px-5 py-3 text-sm bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-xl flex items-center space-x-2 shadow-lg disabled:opacity-50">
//                                 <FileText className="h-5 w-5" /><span className="font-medium">{translations[language].AllDocuments}</span>
//                             </button>
//                         )}
//                     </div>

//                     {/* Workflow Actions */}
//                     {[ROLES.PROJECT_INCHARGE, ROLES.SAMANVAY, ROLES.COLLECTOR].includes(userRole) && (
//                         <div className="flex flex-wrap items-center gap-3 p-2 lg:ml-auto border border-purple-200 bg-purple-50 rounded-2xl shadow-sm min-w-max">
//                             {userRole === ROLES.PROJECT_INCHARGE && (
//                                 <button onClick={handleSendToSamanvayClick} disabled={loading || sendingToSamanvay} className={`flex items-center  rounded-xl text-sm px-4 py-2 font-medium shadow-md  bg-purple-600 text-white hover:bg-purple-700 ${buttonDisabled ? "bg-red-600 text-white hover:bg-red-700" :"bg-purple-600 text-white hover:bg-purple-700"}`}>
//                                     {sendingToSamanvay ? <><Loader2 className="mr-2 h-4 w-4 animate-spin" />{translations[language]?.Sending}</> : <span>{translations[language]?.SendToSamanvayOfficer}</span>}
//                                 </button>
//                             )}
//                             {userRole === ROLES.SAMANVAY && (
//                                 <>
//                                     <button onClick={() => { if (buttonDisabled) { showConfirm('Confirm', 'Already sent. Send again?', () => { setSendToRole('Collector'); setShowSendToCollectorModal(true); fetchUsersCollector(); }); return; } setSendToRole('Collector'); setShowSendToCollectorModal(true); fetchUsersCollector(); }} disabled={loading || sendingToCollector} className={`flex items-center px-5 py-2.5 rounded-xl text-sm font-medium shadow-md ${buttonDisabled ? 'bg-red-600 text-white' : 'bg-purple-600 text-white'}`}>
//                                         {sendingToCollector ? <><Loader2 className="mr-2 h-4 w-4 animate-spin" />{translations[language]?.Sending}</> : <span>{translations[language]?.SendToCollector}</span>}
//                                     </button>
//                                     <button onClick={() => setShowBackToProjectInchargeModal(true)} disabled={loading} className="flex items-center px-5 py-2.5 rounded-xl text-sm font-medium shadow-md bg-orange-600 text-white">
//                                         <span>{translations[language]?.BackToProjectIncharge}</span>
//                                     </button>
//                                 </>
//                             )}
//                             {userRole === ROLES.COLLECTOR && (
//                                 <>
//                                     <button onClick={handleSendToLAOClick} disabled={loading || sendingToLAO} className={`flex items-center px-5 py-2.5 rounded-xl text-sm font-medium shadow-md ${buttonDisabled ? 'bg-red-600 text-white' : 'bg-purple-600 text-white'}`}>
//                                         {sendingToLAO ? <><Loader2 className="mr-2 h-4 w-4 animate-spin" />{translations[language]?.Assigning}</> : <span>{translations[language]?.AssignLAOOfficer}</span>}
//                                     </button>
//                                     <button onClick={() => setShowBackToSamanvayModal(true)} disabled={loading} className="flex items-center px-5 py-2.5 rounded-xl text-sm font-medium shadow-md bg-orange-600 text-white">
//                                         <span>Back to Samanvay</span>
//                                     </button>
//                                 </>
//                             )}
//                         </div>
//                     )}
//                 </div>
//             </div>

//             {/* Proposal Locations List & Village-Wise Tables */}
//             {[ROLES.PROJECT_INCHARGE, ROLES.DATA_ENTRY].includes(userRole) && (
//                 <div className="mb-6 bg-gray-50/50 backdrop-blur-sm border border-gray-200 rounded-lg p-6">
//                     <div className="mb-6 flex flex-col sm:flex-row justify-between items-end gap-4">
//                         <div className="flex-1 w-full max-w-xl">
//                             <label className="block text-sm font-medium text-gray-700 mb-2">{translations[language].search}</label>
//                             <div className="relative">
//                                 <input type="text" placeholder={translations[language].SearchPlaceholder || "Search landholdings..."} value={searchTerm} onChange={handleSearch} className="w-full pl-12 pr-12 py-2 rounded-2xl bg-white border-2 border-gray-200 focus:border-blue-500 focus:ring-4 focus:ring-blue-100 text-sm" />
//                                 <Search className="absolute left-4 top-2.5 h-4 w-4 text-gray-400" />
//                                 {searchTerm && <button onClick={() => setSearchTerm('')} className="absolute right-4 top-2.5 text-gray-400 hover:text-red-500"><X className="h-4 w-4" /></button>}
//                             </div>
//                         </div>
//                         {/* <div className="flex gap-2 w-full sm:w-auto">
//                             <button onClick={handleDownload} className="flex-1 sm:flex-none px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-xl hover:bg-gray-50 flex items-center justify-center gap-2 shadow-sm"><Download className="h-4 w-4"/> Download</button>
//                             <button onClick={handleReport} className="flex-1 sm:flex-none px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-xl hover:bg-gray-50 flex items-center justify-center gap-2 shadow-sm"><FileText className="h-4 w-4"/> Report</button>
//                         </div> */}
//                     </div>

//                     <div className="space-y-6">
//                         {loading ? (
//                             <div className="flex justify-center p-8"><Loader2 className="h-8 w-8 animate-spin text-purple-500" /></div>
//                         ) : (
//                             proposalLocations.map((loc, idx) => {
//                                 // Filter data specifically for this village using robust string matching
//                                 const villageRecords = filteredData.filter(r => 
//                                     String(r.DistrictName || '').trim().toLowerCase() === String(loc.dist_name || '').trim().toLowerCase() && 
//                                     String(r.TalukaName || '').trim().toLowerCase() === String(loc.taluka_name || '').trim().toLowerCase() && 
//                                     String(r.VillageName || '').trim().toLowerCase() === String(loc.village_name || '').trim().toLowerCase()
//                                 );

//                                 return (
//                                     <div key={idx} className="bg-white border border-gray-200 rounded-lg shadow-sm overflow-hidden">
                                        
//                                         {/* Village Header */}
//                                         <div className="flex flex-col sm:flex-row sm:items-center justify-between p-4 bg-gray-50 border-b border-gray-200">
//                                             <div className="flex flex-wrap gap-4 sm:gap-8 mb-4 sm:mb-0">
//                                                 <div className="flex flex-col"><span className="text-xs text-gray-500 uppercase">{translations[language].District}</span><span className="font-semibold">{loc.dist_name}</span></div>
//                                                 <div className="flex flex-col"><span className="text-xs text-gray-500 uppercase">{translations[language].taluka}</span><span className="font-semibold">{loc.taluka_name}</span></div>
//                                                 <div className="flex flex-col"><span className="text-xs text-gray-500 uppercase">{translations[language].village}</span><span className="font-semibold">{loc.village_name}</span></div>
//                                             </div>

//                                             {[18, 14].includes(userRole) && (
//                                                 <button onClick={() => handleAddNew(loc, idx)} disabled={buttonDisabled} className="px-4 py-2 text-sm rounded-lg flex items-center gap-2 bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50">
//                                                     <Plus className="h-4 w-4" /><span>{translations[language].AddLandholding}</span>
//                                                 </button>
//                                             )}
//                                         </div>

//                                         {/* Dynamic Add Form for this specific village block */}
//                                         {activeAddFormIndex === idx && (
//                                             <div className="bg-white p-4 border-b border-gray-200 shadow-inner">
//                                                 <AddLandholdingList
//                                                     onBack={() => setActiveAddFormIndex(null)}
//                                                     onSuccess={() => { setActiveAddFormIndex(null); fetchLandholdingData(); }}
//                                                     projectId={currentProjectId}
//                                                     proposalId={proposalId}
//                                                 />
//                                             </div>
//                                         )}

//                                         {/* Dynamic Edit Form for a record matched to this village block */}
//                                         {editingLandholding && 
//                                          String(editingLandholding.DistrictName || '').trim().toLowerCase() === String(loc.dist_name || '').trim().toLowerCase() &&
//                                          String(editingLandholding.TalukaName || '').trim().toLowerCase() === String(loc.taluka_name || '').trim().toLowerCase() &&
//                                          String(editingLandholding.VillageName || '').trim().toLowerCase() === String(loc.village_name || '').trim().toLowerCase() && (
//                                             <div className="bg-white p-4 border-b border-gray-200 shadow-inner">
//                                                 <EditLandholdingList
//                                                     onBack={() => setEditingLandholding(null)}
//                                                     onSuccess={() => { setEditingLandholding(null); fetchLandholdingData(); }}
//                                                     LandAcquisition_id={editingLandholding.groupNo}
//                                                 />
//                                             </div>
//                                         )}

//                                         {/* Village-Specific Landholding Table */}
//                                         <div className="p-4">
//                                             {villageRecords.length > 0 ? (
//                                                 <div className="overflow-x-auto rounded border border-gray-200">
//                                                     <table className="min-w-full bg-white divide-y divide-gray-200">
//                                                         <thead className="bg-blue-50">
//                                                             <tr>
//                                                                 {[18, 14].includes(userRole) && <th className="p-3 text-left text-xs font-medium text-gray-500 uppercase">{translations[language].Action}</th>}
//                                                                 <th className="p-3 text-left text-xs font-medium text-gray-500 uppercase">{translations[language].LandholdersName}</th>
//                                                                 <th className="p-3 text-left text-xs font-medium text-gray-500 uppercase">{translations[language].AddSurveyGatNo}</th>
//                                                                 <th className="p-3 text-left text-xs font-medium text-gray-500 uppercase">{translations[language].TotalArea}</th>
//                                                                 <th className="p-3 text-left text-xs font-medium text-gray-500 uppercase">{translations[language].AcquiredArea}</th>
//                                                                 <th className="p-3 text-left text-xs font-medium text-gray-500 uppercase">{translations[language].areaUnit}</th>
//                                                             </tr>
//                                                         </thead>
//                                                         <tbody className="divide-y divide-gray-200">
//                                                             {villageRecords.map((record) => (
//                                                                 <React.Fragment key={record.groupNo}>
//                                                                     <tr className="hover:bg-gray-50">
//                                                                         {[18, 14].includes(userRole) && (
//                                                                             <td className="p-3">
//                                                                                 <div className="flex space-x-2">
//                                                                                     <button 
//                                                                                         onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleEdit(record); }} 
//                                                                                         className="text-blue-500 hover:bg-blue-50 p-2 rounded"
//                                                                                     >
//                                                                                         <Edit2 size={16} />
//                                                                                     </button>
//                                                                                     <button 
//                                                                                         onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleDelete(record); }} 
//                                                                                         className="text-red-500 hover:bg-red-50 p-2 rounded"
//                                                                                     >
//                                                                                         <Trash2 size={16} />
//                                                                                     </button>
//                                                                                 </div>
//                                                                             </td>
//                                                                         )}
//                                                                         <td className="p-3">
//                                                                             <div className="flex items-center space-x-2">
//                                                                                 {record.owners?.length > 0 && (
//                                                                                     <button onClick={() => toggleRow(record.groupNo)} className="text-blue-500">
//                                                                                         <svg className={`w-4 h-4 transform ${expandedRow === record.groupNo ? 'rotate-180' : ''}`} fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" /></svg>
//                                                                                     </button>
//                                                                                 )}
//                                                                                 <span title={record.landholdersName}>{truncateName(record.landholdersName)}</span>
//                                                                             </div>
//                                                                         </td>
//                                                                         <td className="p-3 text-gray-700">{record.SurveyNO}</td>
//                                                                         <td className="p-3 text-gray-700">{record.totalArea}</td>
//                                                                         <td className="p-3 text-gray-700">{record.AquiredArea}</td>
//                                                                         <td className="p-3"><span className="px-2.5 py-0.5 rounded-full text-xs bg-blue-100 text-blue-800">{record.unit_name}</span></td>
//                                                                     </tr>
//                                                                     {expandedRow === record.groupNo && record.owners?.length > 0 && (
//                                                                         <tr className="bg-blue-50">
//                                                                             <td colSpan={10} className="p-4">
//                                                                                 <div className="border border-blue-200 rounded-lg overflow-hidden shadow-sm">
//                                                                                     <table className="min-w-full divide-y divide-blue-200">
//                                                                                         <thead className="bg-blue-100">
//                                                                                             <tr>
//                                                                                                 <th className="p-2 pl-4 text-left text-xs font-semibold text-blue-800 uppercase tracking-wider">{translations[language].LandNo}</th>
//                                                                                                 <th className="p-2 text-left text-xs font-semibold text-blue-800 uppercase tracking-wider">{translations[language].ownerName}</th>
//                                                                                                 <th className="p-2 text-left text-xs font-semibold text-blue-800 uppercase tracking-wider">{translations[language].DistrictName}</th>
//                                                                                                 <th className="p-2 text-left text-xs font-semibold text-blue-800 uppercase tracking-wider">{translations[language].TalukaName}</th>
//                                                                                                 <th className="p-2 text-left text-xs font-semibold text-blue-800 uppercase tracking-wider">{translations[language].VillageName}</th>
//                                                                                                 <th className="p-2 text-left text-xs font-semibold text-blue-800 uppercase tracking-wider">{translations[language].SurveyNo}</th>
//                                                                                                 <th className="p-2 text-left text-xs font-semibold text-blue-800 uppercase tracking-wider">{translations[language].TotalArea}</th>
//                                                                                                 <th className="p-2 text-left text-xs font-semibold text-blue-800 uppercase tracking-wider">{translations[language].AcquiredArea}</th>
//                                                                                                 <th className="p-2 pr-4 text-left text-xs font-semibold text-blue-800 uppercase tracking-wider">{translations[language].areaUnit}</th>
//                                                                                             </tr>
//                                                                                         </thead>
//                                                                                         <tbody className="divide-y divide-blue-100 bg-white">
//                                                                                             {record.owners.map((owner, ownerIndex) => (
//                                                                                                 <tr key={owner.land_owner_id} className={`hover:bg-blue-50 transition-colors duration-150 ${ownerIndex % 2 === 0 ? 'bg-blue-25' : 'bg-white'}`}>
//                                                                                                     <td className="p-2 pl-4 text-sm text-gray-700 font-medium">{owner.LandAcquisition_id}</td>
//                                                                                                     <td className="p-2 text-sm text-gray-900 font-medium" title={owner.owner_name}>{truncateName(owner.owner_name, 20)}</td>
//                                                                                                     <td className="p-2 text-sm text-gray-600">{owner.dist_name}</td>
//                                                                                                     <td className="p-2 text-sm text-gray-600">{owner.taluka_name}</td>
//                                                                                                     <td className="p-2 text-sm text-gray-600">{owner.village_name}</td>
//                                                                                                     <td className="p-2 text-sm text-gray-600">{owner.survey_no}</td>
//                                                                                                     <td className="p-2 text-sm text-gray-800 font-medium">{owner.owner_total_area}</td>
//                                                                                                     <td className="p-2 text-sm text-gray-800 font-medium">{owner.owner_aqr_area}</td>
//                                                                                                     <td className="p-2 pr-4">
//                                                                                                         <span className="inline-flex items-center px-2 py-1 rounded-full text-[10px] font-medium bg-blue-100 text-blue-800">
//                                                                                                             {record.unit_name}
//                                                                                                         </span>
//                                                                                                     </td>
//                                                                                                 </tr>
//                                                                                             ))}
//                                                                                         </tbody>
//                                                                                     </table>
//                                                                                 </div>
//                                                                             </td>
//                                                                         </tr>
//                                                                     )}
//                                                                 </React.Fragment>
//                                                             ))}
//                                                         </tbody>
//                                                     </table>
//                                                 </div>
//                                             ) : (
//                                                 <div className="text-center py-6 text-gray-500">
//                                                     <p>No landholdings added for {loc.village_name} yet.</p>
//                                                 </div>
//                                             )}
//                                         </div>
//                                     </div>
//                                 );
//                             })
//                         )}

//                         {/* Fallback for unmapped records (if legacy data has mismatching loc strings) */}
//                         {!loading && (() => {
//                             const mappedIds = new Set();
//                             proposalLocations.forEach(loc => {
//                                 filteredData.forEach(r => {
//                                     if (String(r.DistrictName).trim().toLowerCase() === String(loc.dist_name).trim().toLowerCase() && 
//                                         String(r.TalukaName).trim().toLowerCase() === String(loc.taluka_name).trim().toLowerCase() && 
//                                         String(r.VillageName).trim().toLowerCase() === String(loc.village_name).trim().toLowerCase()) {
//                                         mappedIds.add(r.groupNo);
//                                     }
//                                 });
//                             });
                            
//                             const unmappedRecords = filteredData.filter(r => !mappedIds.has(r.groupNo));
//                             if (unmappedRecords.length === 0) return null;

//                             const isUnmappedEditing = editingLandholding && unmappedRecords.some(r => r.groupNo === editingLandholding.groupNo);

//                             return (
//                                 <div className="mt-8 bg-white border border-red-200 rounded-lg shadow-sm overflow-hidden">
//                                     <div className="bg-red-50 p-4 border-b border-red-200">
//                                         <h3 className="text-red-800 font-semibold">Other / Unmapped Landholdings</h3>
//                                         <p className="text-xs text-red-600 mt-1">These legacy records do not exactly match the District/Taluka/Village strings mapped to the current proposal.</p>
//                                     </div>

//                                     {isUnmappedEditing && (
//                                         <div className="bg-white p-4 border-b border-red-200 shadow-inner">
//                                             <EditLandholdingList
//                                                 onBack={() => setEditingLandholding(null)}
//                                                 onSuccess={() => { setEditingLandholding(null); fetchLandholdingData(); }}
//                                                 LandAcquisition_id={editingLandholding.groupNo}
//                                             />
//                                         </div>
//                                     )}

//                                     <div className="p-4">
//                                         <div className="overflow-x-auto rounded border border-gray-200">
//                                             <table className="min-w-full bg-white divide-y divide-gray-200">
//                                                 <thead className="bg-red-50">
//                                                     <tr>
//                                                         {[18, 14].includes(userRole) && <th className="p-3 text-left text-xs font-medium text-gray-500 uppercase">{translations[language].Action}</th>}
//                                                         <th className="p-3 text-left text-xs font-medium text-gray-500 uppercase">District</th>
//                                                         <th className="p-3 text-left text-xs font-medium text-gray-500 uppercase">Taluka</th>
//                                                         <th className="p-3 text-left text-xs font-medium text-gray-500 uppercase">Village</th>
//                                                         <th className="p-3 text-left text-xs font-medium text-gray-500 uppercase">{translations[language].LandholdersName}</th>
//                                                     </tr>
//                                                 </thead>
//                                                 <tbody className="divide-y divide-gray-200">
//                                                     {unmappedRecords.map((record) => (
//                                                         <React.Fragment key={record.groupNo}>
//                                                             <tr className="hover:bg-gray-50">
//                                                                 {[18, 14].includes(userRole) && (
//                                                                     <td className="p-3">
//                                                                         <div className="flex space-x-2">
//                                                                             <button 
//                                                                                 onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleEdit(record); }} 
//                                                                                 className="text-blue-500 hover:bg-blue-50 p-2 rounded"
//                                                                             >
//                                                                                 <Edit2 size={16} />
//                                                                             </button>
//                                                                             <button 
//                                                                                 onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleDelete(record); }} 
//                                                                                 className="text-red-500 hover:bg-red-50 p-2 rounded"
//                                                                             >
//                                                                                 <Trash2 size={16} />
//                                                                             </button>
//                                                                         </div>
//                                                                     </td>
//                                                                 )}
//                                                                 <td className="p-3 text-gray-700">{record.DistrictName}</td>
//                                                                 <td className="p-3 text-gray-700">{record.TalukaName}</td>
//                                                                 <td className="p-3 text-gray-700">{record.VillageName}</td>
//                                                                 <td className="p-3 text-gray-700">
//                                                                     <div className="flex items-center space-x-2">
//                                                                         {record.owners?.length > 0 && (
//                                                                             <button onClick={() => toggleRow(record.groupNo)} className="text-blue-500">
//                                                                                 <svg className={`w-4 h-4 transform ${expandedRow === record.groupNo ? 'rotate-180' : ''}`} fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" /></svg>
//                                                                             </button>
//                                                                         )}
//                                                                         <span title={record.landholdersName}>{truncateName(record.landholdersName)}</span>
//                                                                     </div>
//                                                                 </td>
//                                                             </tr>
//                                                             {expandedRow === record.groupNo && record.owners?.length > 0 && (
//                                                                 <tr className="bg-red-50/50">
//                                                                     <td colSpan={10} className="p-4">
//                                                                         <div className="border border-red-200 rounded-lg overflow-hidden shadow-sm">
//                                                                             <table className="min-w-full divide-y divide-red-200">
//                                                                                 <thead className="bg-red-100">
//                                                                                     <tr>
//                                                                                         <th className="p-2 pl-4 text-left text-xs font-semibold text-red-800 uppercase tracking-wider">{translations[language].LandNo}</th>
//                                                                                         <th className="p-2 text-left text-xs font-semibold text-red-800 uppercase tracking-wider">{translations[language].ownerName}</th>
//                                                                                         <th className="p-2 text-left text-xs font-semibold text-red-800 uppercase tracking-wider">{translations[language].SurveyNo}</th>
//                                                                                         <th className="p-2 text-left text-xs font-semibold text-red-800 uppercase tracking-wider">{translations[language].TotalArea}</th>
//                                                                                         <th className="p-2 text-left text-xs font-semibold text-red-800 uppercase tracking-wider">{translations[language].AcquiredArea}</th>
//                                                                                     </tr>
//                                                                                 </thead>
//                                                                                 <tbody className="divide-y divide-red-100 bg-white">
//                                                                                     {record.owners.map(owner => (
//                                                                                         <tr key={owner.land_owner_id}>
//                                                                                             <td className="p-2 pl-4 text-sm text-gray-700">{owner.LandAcquisition_id}</td>
//                                                                                             <td className="p-2 text-sm text-gray-900">{truncateName(owner.owner_name, 20)}</td>
//                                                                                             <td className="p-2 text-sm text-gray-600">{owner.survey_no}</td>
//                                                                                             <td className="p-2 text-sm text-gray-800">{owner.owner_total_area}</td>
//                                                                                             <td className="p-2 text-sm text-gray-800">{owner.owner_aqr_area}</td>
//                                                                                         </tr>
//                                                                                     ))}
//                                                                                 </tbody>
//                                                                             </table>
//                                                                         </div>
//                                                                     </td>
//                                                                 </tr>
//                                                             )}
//                                                         </React.Fragment>
//                                                     ))}
//                                                 </tbody>
//                                             </table>
//                                         </div>
//                                     </div>
//                                 </div>
//                             );
//                         })()}
//                     </div>
//                 </div>
//             )}

//             {/* Modals */}
//             <DownloadModal isOpen={downloadModalOpen} onClose={() => setDownloadModalOpen(false)} title={translations[language].LandholdingManagement} data={getDataForDownload()} columns={getColumnsForDownload()} isLoading={downloadLoading} setIsLoading={setDownloadLoading} screenName="Landholding Management" />

//             {showAlertModal && (
//                 <div className="fixed top-4 right-4 z-50">
//                     <div className={`bg-white rounded-lg shadow-lg border-l-4 p-4 max-w-sm ${alertConfig.type === 'error' ? 'border-red-500' : 'border-green-500'}`}>
//                         <div className="flex justify-between items-start">
//                             <div><h3 className="text-sm font-medium">{alertConfig.title}</h3><p className="text-sm text-gray-600">{alertConfig.message}</p></div>
//                             <button onClick={() => setShowAlertModal(false)}><X className="h-4 w-4" /></button>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {showSendToCollectorModal && (
//                 <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//                     <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto">
//                         <div className="p-6">
//                             <h3 className="text-lg font-semibold mb-4">Send Document</h3>
//                             <div className="space-y-4">
//                                 {sendToRole === 'Collector' && (
//                                     <div>
//                                         <label className="block text-sm mb-2">{translations[language]?.SelectCollector || 'Select Collector'}</label>
//                                         <select value={selectedUser} onChange={(e) => setSelectedUser(e.target.value)} className="w-full p-2 border rounded">
//                                             <option value="">{translations[language]?.SelectCollector || 'Select Collector'}</option>
//                                             {users.map(u => <option key={u.id || u.usr_id} value={u.id || u.usr_id}>{u.full_name || u.user_name}</option>)}
//                                         </select>
//                                     </div>
//                                 )}
//                                 {sendToRole === 'LAO' && (
//                                     <div>
//                                         <label className="block text-sm mb-2">{translations[language]?.SelectLAOOfficer || 'Select LAO Officer'}</label>
//                                         <select value={selectedLao} onChange={(e) => setSelectedLao(e.target.value)} className="w-full p-2 border rounded">
//                                             <option value="">{translations[language]?.SelectLAOOfficer || 'Select LAO Officer'}</option>
//                                             {assignLAO && Array.isArray(assignLAO) && assignLAO.map((u) => <option key={u.usr_id || u.id} value={u.usr_id || u.id}>{u.full_name || u.user_name}</option>)}
//                                             {laoUsers && Array.isArray(laoUsers) && laoUsers.filter(lao => !assignLAO?.some(assigned => (assigned.usr_id || assigned.id) === (lao.usr_id || lao.id))).map(u => <option key={u.usr_id || u.id} value={u.usr_id || u.id}>{u.full_name || u.user_name}</option>)}
//                                         </select>
//                                     </div>
//                                 )}
//                                 {sendToRole === 'Samanvay' && (
//                                     <div>
//                                         <label className="block text-sm mb-2">{translations[language]?.SelectSamanvayOfficer || 'Select Samanvay Officer'}</label>
//                                         <select value={selectedUser} onChange={(e) => setSelectedUser(e.target.value)} className="w-full p-2 border rounded">
//                                             <option value="">{translations[language]?.SelectSamanvayOfficer || 'Select Samanvay Officer'}</option>
//                                             {users.map(u => <option key={u.id || u.usr_id} value={u.id || u.usr_id}>{u.full_name || u.user_name}</option>)}
//                                         </select>
//                                     </div>
//                                 )}
//                                 <div>
//                                     <label className="block text-sm mb-2">{translations[language]?.Remarks || 'Remarks'}</label>
//                                     <textarea value={remarks} onChange={e => setRemarks(e.target.value)} rows={3} className="w-full p-2 border rounded" />
//                                 </div>
//                                 {([ROLES.COLLECTOR, ROLES.PROJECT_INCHARGE, ROLES.SAMANVAY].includes(userRole)) && (
//                                     <div>
//                                         <label className="block text-sm font-medium text-gray-700 mb-2">
//                                             {translations[language]?.UploadDocument || 'Upload Document'} *
//                                         </label>
//                                         <input
//                                             type="file"
//                                             onChange={e => setSelectedDocument(e.target.files[0])}
//                                             className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
//                                             accept=".pdf,.doc,.docx,.jpg,.png"
//                                         />
//                                         {selectedDocument && (
//                                             <div className="mt-2 p-3 bg-green-50 rounded-lg border border-green-200">
//                                                 <div className="flex items-center justify-between mb-2">
//                                                     <p className="text-sm text-green-700 font-medium truncate max-w-[60%]">
//                                                         {translations[language]?.Selected || 'Selected'}: {selectedDocument.name}
//                                                     </p>
//                                                     <span className="text-xs text-green-600 bg-green-100 px-2 py-1 rounded-full">
//                                                         {(selectedDocument.size / 1024 / 1024).toFixed(2)} MB
//                                                     </span>
//                                                 </div>
//                                                 <div className="flex gap-2">
//                                                     {selectedDocument.type === 'application/pdf' && (
//                                                         <>
//                                                             <button
//                                                                 type="button"
//                                                                 onClick={() => {
//                                                                     setPdfForSigning(selectedDocument);
//                                                                     setShowSignaturePad(true);
//                                                                 }}
//                                                                 disabled={uploadStatus === 'uploading'}
//                                                                 className="px-3 py-1 text-xs bg-purple-600 text-white rounded hover:bg-purple-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center gap-1 transition-colors"
//                                                             >
//                                                                 {uploadStatus === 'uploading' ? (
//                                                                     <>
//                                                                         <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-white"></div>
//                                                                         Signing...
//                                                                     </>
//                                                                 ) : (
//                                                                     <>
//                                                                         <svg className="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                                                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
//                                                                         </svg>
//                                                                         Sign Doc
//                                                                     </>
//                                                                 )}
//                                                             </button>
//                                                             <button
//                                                                 type="button"
//                                                                 onClick={() => handleViewDocument(uploadStatus === 'success' ? selectedSignDocument : selectedDocument)}
//                                                                 className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1 transition-colors"
//                                                             >
//                                                                 <Eye className="h-3 w-3" />
//                                                                 {translations[language]?.View || 'View'}
//                                                             </button>
//                                                         </>
//                                                     )}
//                                                 </div>
//                                                 {uploadStatus === 'success' && (
//                                                     <div className="mt-2 p-2 bg-green-100 border border-green-300 rounded text-xs text-green-700">
//                                                         ✅ Document Signed Successfully
//                                                     </div>
//                                                 )}
//                                                 {uploadStatus === 'error' && uploadError && (
//                                                     <div className="mt-2 p-2 bg-red-100 border border-red-300 rounded text-xs text-red-700">
//                                                         ❌ {uploadError}
//                                                     </div>
//                                                 )}
//                                             </div>
//                                         )}
//                                     </div>
//                                 )}
//                             </div>
//                             <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
//                                 <button onClick={() => setShowSendToCollectorModal(false)} className="px-4 py-2 border rounded hover:bg-gray-50">{translations[language]?.Cancel || 'Cancel'}</button>
//                              <button
//   onClick={handleSendToSurveyor}
//   disabled={showProgress}
//   className="px-4 py-2 bg-blue-600 text-white rounded flex items-center"
// >
//   {showProgress ? (
//     <>
//       <Loader2 className="animate-spin w-4 h-4 mr-2" />
//       {translations[language].Sending}
//     </>
//   ) : (
//     <>
//       <Send className="w-4 h-4 mr-2" />
//       {translations[language].Send}
//     </>
//   )}
// </button>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {/* ---> RESTORED: Document Preview Modal <--- */}
//             {showModal && (
//                 <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black bg-opacity-50">
//                     <div className="bg-white rounded-xl shadow-2xl w-full max-w-4xl mx-4 max-h-[90vh] overflow-hidden flex flex-col">
//                         <div className="flex justify-between items-center p-4 border-b">
//                             <h3 className="text-xl font-semibold text-gray-800">{translations[language]?.DocumentPreview || 'Document Preview'}</h3>
//                             <button
//                                 onClick={() => {
//                                     setShowModal(false);
//                                     if (documentUrl) URL.revokeObjectURL(documentUrl);
//                                 }}
//                                 className="text-gray-400 hover:text-gray-700 text-2xl font-bold"
//                             >
//                                 ×
//                             </button>
//                         </div>
//                         <div className="flex-1 p-4 overflow-hidden">
//                             <iframe
//                                 src={documentUrl}
//                                 className="w-full h-[70vh] rounded border border-gray-300"
//                                 title="Document Preview"
//                             />
//                         </div>
//                     </div>
//                 </div>
//             )}
            
//             {showSignaturePad && pdfForSigning && (
//                 <SignaturePad pdfFile={pdfForSigning} onSign={(sigs) => { setShowSignaturePad(false); signDocument(pdfForSigning, sigs).then(() => setPdfForSigning(null)); }} onCancel={() => { setShowSignaturePad(false); setPdfForSigning(null); }} />
//             )}

//             {isViewerOpen && viewerFile && (
//                 <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
//                     <div className="bg-white rounded-lg w-[80%] max-w-6xl h-[80%] relative">
//                         <div className="flex justify-between p-4 border-b">
//                             <h3 className="text-lg font-semibold">Signed Document</h3>
//                             <button onClick={() => setIsViewerOpen(false)}>✕</button>
//                         </div>
//                         <iframe src={viewerFile} className="w-full h-full" title="PDF viewer" />
//                     </div>
//                 </div>
//             )}

//             {showConfirmModal && (
//                 <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//                     <div className="bg-white rounded-lg shadow-lg w-full max-w-sm mx-4">
//                         <div className="p-6">
//                             <div className={`w-12 h-12 rounded-full mx-auto mb-4 flex items-center justify-center ${confirmConfig.type === 'danger' ? 'bg-red-100' :
//                                 confirmConfig.type === 'warning' ? 'bg-yellow-100' :
//                                     'bg-blue-100'
//                                 }`}>
//                                 {confirmConfig.type === 'danger' ? '⚠' :
//                                     confirmConfig.type === 'warning' ? '⚠' : '?'}
//                             </div>
//                             <h3 className="text-lg font-semibold text-gray-900 mb-2 text-center">
//                                 {confirmConfig.title}
//                             </h3>
//                             <p className="text-gray-600 text-sm mb-6 text-center">
//                                 {confirmConfig.message}
//                             </p>
//                             <div className="flex gap-3">
//                                 <button
//                                     onClick={() => {
//                                         if (confirmConfig.onCancel) confirmConfig.onCancel();
//                                         setShowConfirmModal(false);
//                                     }}
//                                     className="flex-1 py-2 px-4 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition-colors"
//                                 >
//                                     {translations[language]?.Cancel || 'Cancel'}
//                                 </button>
//                                 <button
//                                     onClick={() => {
//                                         if (confirmConfig.onConfirm) confirmConfig.onConfirm();
//                                         setShowConfirmModal(false);
//                                     }}
//                                     className={`flex-1 py-2 px-4 text-white rounded-md transition-colors ${confirmConfig.type === 'danger' ? 'bg-red-600 hover:bg-red-700' :
//                                         confirmConfig.type === 'warning' ? 'bg-yellow-600 hover:bg-yellow-700' :
//                                             'bg-blue-600 hover:bg-blue-700'
//                                         }`}
//                                 >
//                                     {translations[language]?.Confirm || 'Confirm'}
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             )}
            
//             {userRole === ROLES.SAMANVAY && <SendTrackingModal isOpen={showBackToProjectInchargeModal} onClose={() => setShowBackToProjectInchargeModal(false)} role="BackToProjectIncharge" projectId={currentProjectId} proposalId={proposalId} translations={translations} language={language} onSuccess={() => { setShowBackToProjectInchargeModal(false); fetchLandholdingData(); }} />}
//             {userRole === ROLES.COLLECTOR && <SendTrackingModal isOpen={showBackToSamanvayModal} onClose={() => setShowBackToSamanvayModal(false)} role="Back_Collector" projectId={currentProjectId} proposalId={proposalId} translations={translations} language={language} onSuccess={() => { setShowBackToSamanvayModal(false); fetchLandholdingData(); }} />}
//         </div>
//     );
// };

// export default LandholdingList;

import React, { useState, useEffect, useRef } from 'react';
import { Edit, Trash2, Plus, Search, X, Download, MapPin, FileText, Edit2, Send, Eye, Loader2, Globe, Filter, Briefcase, ChevronDown, ChevronUp } from 'lucide-react';
import { useLanguage } from '../StoreContext/LanguageContext';
import DownloadModal from '../Components/Download/DownloadModal';
import apiService from '../config';
import Parishtisht1Notice from "./Parishtisht1Notice";
import Parishtisht6Notice from "./Parishtisht6Notice";
import AddLandholdingList from "./AddLandholdingList";
import EditLandholdingList from "./EditLandholdinglist";
import { useSignature } from '../DigitalSignature/UseSignatue';
import SignaturePad from '../DigitalSignature/SignaturePad';
import SendTrackingModal from '../CommonModel/SendTrackingModal';
import EditProposal from "./EditProposal";

const LandholdingList = ({ onBack, setSelectedComponent, onNavigateWithModal, setSubComponent, shouldRestoreModal, modalParams, setShouldRestoreModal }) => {
    const { language, translations } = useLanguage();
    const formRef = useRef(null);
    const listRef = useRef(null);
    
    // Core Data States
    const [landholdingData, setLandholdingData] = useState([]);
    const [selectedLandId, setSelectedLandId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [downloadModalOpen, setDownloadModalOpen] = useState(false);
    const [downloadLoading, setDownloadLoading] = useState(false);
    
    // Project & Proposal States
    const [currentProjectId, setCurrentProjectId] = useState(null);
    const [selectedProject, setSelectedProject] = useState(() => {
        try {
            const project = localStorage.getItem("selectedProject");
            return project ? JSON.parse(project) : null;
        } catch (error) {
            console.error("Error parsing project data:", error);
            return null;
        }
    });
    const [proposalId, setProposalId] = useState(null);
    const [proposalLocations, setProposalLocations] = useState([]);
    
    // UI & Form States
    const [isViewerOpen, setIsViewerOpen] = useState(false);
    const [viewerFile, setViewerFile] = useState(null);
    const [editProposalMode, setEditProposalMode] = useState(false);
    const [showAddForm, setShowAddForm] = useState(false);
    const [showEditForm, setShowEditForm] = useState(false);
    const [editingLandholding, setEditingLandholding] = useState(null);
    const [activeAddFormIndex, setActiveAddFormIndex] = useState(null);
    const [expandedRow, setExpandedRow] = useState(null);
    const [filterMode, setFilterMode] = useState('all');

    // Modal & Tracking States
    const [showAlertModal, setShowAlertModal] = useState(false);
    const [alertConfig, setAlertConfig] = useState({ title: '', message: '', type: 'success' });
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [confirmConfig, setConfirmConfig] = useState({ title: '', message: '', onConfirm: null, onCancel: null, type: 'warning' });
    const [showSendToCollectorModal, setShowSendToCollectorModal] = useState(false);
    const [showBackToProjectInchargeModal, setShowBackToProjectInchargeModal] = useState(false);
    const [showBackToSamanvayModal, setShowBackToSamanvayModal] = useState(false);
    const [showModal, setShowModal] = useState(false); // Document preview modal

    // Users & Roles
    const [users, setUsers] = useState([]);
    const [laoUsers, setLaoUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState('');
    const [selectedLao, setSelectedLao] = useState('');
    const [assignLAO, setAssignLAO] = useState('');
    const [sendToRole, setSendToRole] = useState('LAO');
    const [loadingUsers, setLoadingUsers] = useState(false);
    const [buttonDisabled, setButtonDisabled] = useState(false);

    // Tracking Senders
    const [trackingSenderName, setTrackingSenderName] = useState('');
    const [trackingSenderUserId, setTrackingSenderUserId] = useState('');
    const [samanvaySenderName, setSamanvaySenderName] = useState('');
    const [samanvaySenderUserId, setSamanvaySenderUserId] = useState('');
    
    // Actions & Document Upload
    const [remarks, setRemarks] = useState('Approved');
    const [selectedDocument, setSelectedDocument] = useState(null);
    const [documentUrl, setDocumentUrl] = useState('');
    const [sendingToSamanvay, setSendingToSamanvay] = useState(false);
    const [sendingToCollector, setSendingToCollector] = useState(false);
    const [sendingToLAO, setSendingToLAO] = useState(false);
    const [showProgress, setShowProgress] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [successMessage, setSuccessMessage] = useState('');
    const [showSuccess, setShowSuccess] = useState(false);
    
    // Digital Signature
    const { uploadStatus, uploadError, selectedSignDocument, signDocument } = useSignature();
    const [showSignaturePad, setShowSignaturePad] = useState(false);
    const [pdfForSigning, setPdfForSigning] = useState(null);
    const [isSignedPdfAvailable, setIsSignedPdfAvailable] = useState(false);
    const [isSamanvayDisabled, setIsSamanvayDisabled] = useState(false);
    const [isSamanvayBackDisabled, setIsSamanvayBackDisabled] = useState(false);
    const [isCollectorDisabled, setIsCollectorDisabled] = useState(false);
    const [isLaoAssignDisabled, setIsLaoAssignDisabled] = useState(false);
    const [isSamanvayFinalDisabled, setIsSamanvayFinalDisabled] = useState(false);
    const [isSamanvayFinalBackDisabled, setIsSamanvayFinalBackDisabled] = useState(false);
    const[isBackToProjectIncharge , setIsBackToProjectInchargeDisabled] = useState(false)

    const ROLES = {
        PROJECT_INCHARGE: 18,
        SAMANVAY: 6,
        COLLECTOR: 1,
        LAO: 3,
        DATA_ENTRY: 14
    };

    const pendingRestore = useRef(null);

    const [userRole, setUserRole] = useState(() => {
        try {
            const userData = localStorage.getItem("userData");
            if (userData) {
                const user = JSON.parse(userData);
                // setUserRole(user.user_role)
                return user.user_role || user.usr_role || null;
            }
        } catch (error) {
            console.error("Error parsing user data:", error);
        }
        return null;
    });
    console.log("userRole" , userRole);
    

    const showAlert = (title, message, type = 'info') => {
        setAlertConfig({ title, message, type });
        setShowAlertModal(true);
        setTimeout(() => setShowAlertModal(false), 5000);
    };

    const showConfirm = (title, message, onConfirm, onCancel = null, type = 'warning') => {
        setConfirmConfig({ title, message, onConfirm, onCancel, type });
        setShowConfirmModal(true);
    };

    useEffect(() => {
        const getProjectInfo = () => {
            const selectedProject = localStorage.getItem('selectedProject');
            if (selectedProject) {
                try {
                    const project = JSON.parse(selectedProject);
                    return { id: project.project_id || project.id, name: project.project_name || project.name };
                } catch (e) {
                    console.error('Error parsing selected project:', e);
                }
            }

            const userData = localStorage.getItem('userData');
            if (userData) {
                try {
                    const user = JSON.parse(userData);
                    return { id: user.data?.project_id || user.project_id, name: user.data?.project_name || user.project_name || 'Unknown Project' };
                } catch (e) {
                    console.error('Error parsing user data:', e);
                }
            }
            return { id: null, name: null };
        };

        const projectInfo = getProjectInfo();
        setCurrentProjectId(projectInfo.id);

        const savedProposalId = localStorage.getItem('currentProposalId');
        if (savedProposalId) setProposalId(savedProposalId);
    }, []);

    useEffect(() => {
        if (currentProjectId && proposalId) {
            checkSignedPdfAvailability();
            fetchAssignLAO();
            fetchUsersSamanvay();
            fetchUsersCollector();
            fetchButtonStatus();
            fetchLandholdingData();
        }
    }, [currentProjectId, proposalId, userRole]);

    useEffect(() => {
        const loadLocationData = async () => {
            try {
                const proposalStr = localStorage.getItem('selectedProposal');
                if (proposalStr) {
                    const proposal = JSON.parse(proposalStr);
                    let response;
                    
                    if (proposal?.PROPOSAL_ID) {
                        response = await apiService.get(`/getProposal?proposalId=${proposal.PROPOSAL_ID}`);
                    } else if (proposal?.acquisition_proposal_id) {
                        response = await apiService.get(`/getProposal?proposalId=${proposal.acquisition_proposal_id}`);
                    }

                    if (response?.data) {
                        if (response.data.dtv && Array.isArray(response.data.dtv) && response.data.dtv.length > 0) {
                            setProposalLocations(response.data.dtv);
                        } else {
                            setProposalLocations([{
                                dist_name: response.data.dist_name || proposal.dist_name,
                                taluka_name: response.data.taluka_name || proposal.taluka_name,
                                village_name: response.data.village_name || proposal.village_name
                            }]);
                        }
                    }
                }
            } catch (error) {
                console.error('Error loading default location data:', error);
            }
        };

        if (currentProjectId) loadLocationData();
    }, [currentProjectId]);

    const checkSignedPdfAvailability = async () => {
        try {
            const res = await apiService.getSectionFile(currentProjectId, proposalId, "CoveringLettersSection11");
            setIsSignedPdfAvailable(res?.isSignAvailable && res?.data?.[0]?.file_path);
        } catch (error) {
            console.error("Error checking signed pdf:", error);
            setIsSignedPdfAvailable(false);
        }
    };

    const fetchLandholdingData = async () => {
        try {
            setLoading(true);
            setError(null);
            if (!currentProjectId || !proposalId) return;

            const result = await apiService.getLandHolding(currentProjectId, { proposalId });

            if (result.status === 200 && result.data) {
                const transformedData = result.data.map(item => ({
                    groupNo: item.LandAcquisition_id,
                    landholdersName: item.landholder_name || '',
                    DistrictName: item.dist_name,
                    TalukaName: item.taluka_name,
                    VillageName: item.village_name || 'Unknown Village',
                    SurveyNO: item.survey_no || '',
                    irrigableArea: parseFloat(item.irrigable_area) || 0,
                    nonIrrigableArea: parseFloat(item.non_irrigable_area) || 0,
                    totalArea: parseFloat(item.total_area) || 0,
                    AquiredArea: parseFloat(item.aqr_area) || 0,
                    unit_name: item.unit_name || '',
                    status: item.is_active,
                    owners: item.owners || [],
                }));
                setLandholdingData(transformedData);
            } else {
                setLandholdingData([]);
            }
        } catch (err) {
            console.error('Error fetching landholding data:', err);
            setError(err.message);
            setLandholdingData([]);
        } finally {
            setLoading(false);
        }
    };
const[disable,setDisable] = useState(false)
const [trackingPermissionId, setTrackingPermissionId] = useState(null);

const fetchTrackingPermission = async () => {
  try {
    if (!currentProjectId || !proposalId) return;

    const res = await apiService.getTrackingwiseButton(currentProjectId,proposalId,"landAcquisition");
    const res1 = await apiService.getTrackingPermission(currentProjectId,proposalId,"landAcquisition",userRole);
    console.log("New Tracking" , res1);
    console.log("New Tracking button" , res1?.data[0]?.is_edit);

    setDisable(res1?.data[0]?.is_edit)
    setTrackingPermissionId(res1?.data?.[0]?.id ?? null);

    console.log("API response:", res);

    // Correct mapping
    setButtonDisabled(!res?.isEditable);

  } catch (error) {
    console.error("Error fetching button state:", error);
    setButtonDisabled(true); // fail-safe
  }
};

useEffect(() => {
  fetchTrackingPermission();
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [currentProjectId, proposalId]);

// Keeps /getTrackingPermission's row in sync with the current stage of the
// projectIncharge -> samanvay -> collector -> samanvay -> lao pipeline (plus is_back).
const updateTrackingPermission = async ({ role, is_view, is_edit, is_complete, is_back }) => {
    if (!trackingPermissionId) return;
    try {
        await apiService.patchUpdateTrackingPermission(trackingPermissionId, {
            type: "landAcquisition",
            role,
            is_view: is_view ? 1 : 0,
            is_edit: is_edit ? 1 : 0,
            is_complete: is_complete ? 1 : 0,
            is_back: is_back ? 1 : 0,
            is_active: 1,
        });
        // Refresh permission/button state right away so the UI reflects the new stage.
        await fetchTrackingPermission();
    } catch (error) {
        console.error("Error updating tracking permission:", error);
    }
};
    const fetchButtonStatus = async () => {
    try {
        setLoading(true);
        let isDisabled = false; // Set a default state
        // let isCollectorDisabled = false;
        // let isLaoAssignDisabled = false;
        // let isSamanvayDisabled = false;
        // let isSamanvayFinalDisabled = false;
        const buttonResponse = await apiService.getTrackingwiseButton(currentProjectId,proposalId,"landAcquisition")
        console.log("Tracking Wise button Response" , buttonResponse);
        

        switch (userRole) {
            case ROLES.PROJECT_INCHARGE: {
                const response = await apiService.getSamanvayButton(currentProjectId, proposalId);
                isDisabled = !response?.buttonDisable 
                // setIsSamanvayDisabled(response?.buttonDisable)
                setIsSamanvayDisabled(buttonResponse?.stages?.Samanvay?.active)
                console.log("Tracking Wise button Response inside role" , buttonResponse);
                
                // isSamanvayDisabled = response?.buttonDisable === !true;
                break;
            }
            case ROLES.SAMANVAY: {
                // Call both APIs at the same time for better performance
                const [samanvayResponse,collectorResponse, laoAssignResponse] = await Promise.all([
                    apiService.getSamanvayButton(currentProjectId, proposalId),
                    apiService.getCollectorButton(currentProjectId, proposalId),
                    apiService.getLAOassignButton(currentProjectId, proposalId)
                ]);
                isDisabled = !samanvayResponse?.buttonDisable || !collectorResponse?.buttonDisable || !laoAssignResponse?.buttonDisable
                // Determine individual statuses
                // isSamanvayDisabled = samanvayResponse.buttonDisable === !true;
                // setIsSamanvayDisabled(samanvayResponse.buttonDisable)
                // setIsCollectorDisabled(collectorResponse?.buttonDisable)
                setIsCollectorDisabled(buttonResponse?.stages?.Collector?.active)
                // setIsLaoAssignDisabled(laoAssignResponse?.buttonDisable)
                setIsLaoAssignDisabled(buttonResponse?.stages?.LAO?.active)
                setIsBackToProjectInchargeDisabled(buttonResponse?.stages?.Back_ProjectIncharge?.active)

                
                
                
                // isCollectorDisabled = collectorResponse?.buttonDisable === !true;
                // isLaoAssignDisabled = laoAssignResponse?.buttonDisable === !true;
                

                // Disable if EITHER API returns buttonDisable: true. 
                // Change '||' to '&&' if they BOTH need to be true to disable the button.
                // isDisabled = isCollectorDisabled || isLaoAssignDisabled; 
                break;
            }
            case ROLES.COLLECTOR: {
                const response = await apiService.getSamanvayFinalButton(currentProjectId, proposalId);
                isDisabled = !response?.buttonDisable 
                // isSamanvayFinalDisabled = response?.buttonDisable === !true;
                // setIsSamanvayFinalDisabled(response?.buttonDisable)
                setIsSamanvayFinalDisabled(buttonResponse?.stages?.SamanvayFinal?.active)
                const backresponse = await apiService.getSamanvayBackButton(currentProjectId,proposalId);
                setIsSamanvayBackDisabled(buttonResponse?.stages?.Back_Samanvay?.active)
                setIsSamanvayFinalBackDisabled(buttonResponse?.stages?.Back_SamanvayFinal?.active)
                console.log("Back button Response" , backresponse);
                
                break;
            }
            default:
                return; // Exit if the role doesn't match
        }
      

        // Apply the final calculated state
        console.log("isDisabled" , isDisabled);
        
        // setButtonDisabled(isDisabled);
       
        
        // Note: Check if 'sentToSamanvay' is the right key for ALL roles
        localStorage.setItem('sentToSamanvay', String(isDisabled)); 

    } catch (error) {
        console.error("Error fetching button state:", error);
        // Best practice: Fail safely by disabling the button if the API crashes
        // setButtonDisabled(true); 
    } finally {
        setLoading(false);
    }
};

useEffect(() => {
  console.log({
    isSamanvayDisabled,
    isCollectorDisabled,
    isLaoAssignDisabled,
    isSamanvayFinalDisabled
  });
}, [
  isSamanvayDisabled,
  isCollectorDisabled,
  isLaoAssignDisabled,
  isSamanvayFinalDisabled
]);
    const fetchUsersCollector = async () => {
        setLoadingUsers(true);
        try {
            const response = await apiService.getAllUserCollector(1, currentProjectId, proposalId);
            if (response.status === 200 && response.data) {
                setUsers(Array.isArray(response.data) ? response.data : []);
                if (response.data.length > 0) setSelectedUser(response.data[0].id || response.data[0].usr_id);
            }
        } catch (error) { setUsers([]); } finally { setLoadingUsers(false); }
    };

    const fetchAssignLAO = async () => {
        setLoadingUsers(true);
        try {
            const response = await apiService.getAllAssignUserRoleLAO(3, currentProjectId, proposalId);
            if (response.status === 200 && response.data) setAssignLAO(Array.isArray(response.data) ? response.data : []);
        } catch (error) { setAssignLAO([]); } finally { setLoadingUsers(false); }
    };

    const fetchUsersSamanvay = async () => {
        setLoadingUsers(true);
        try {
            const response = await apiService.getAllAssignUserRoleSamanvay(6, currentProjectId, proposalId);
            console.log("Samanvay user" , response);
            
            if (response.status === 200 && response.data) setUsers(Array.isArray(response.data) ? response.data : []);
        } catch (error) { setUsers([]); } finally { setLoadingUsers(false); }
    };

    const handleAssignLAO = async (laoUserId) => {
        await apiService.getAllUserRoleLAO(3, currentProjectId, proposalId);
    };

    const getFinalDocument = () => selectedSignDocument || selectedDocument || null;

    const handleSendToCollector = async (collectorUserId) => {
        const finalDocument = getFinalDocument();
        if (!finalDocument) return showAlert('Document Required', 'Please upload or sign a document');

        setSendingToCollector(true);
        setShowProgress(true);
        setUploadProgress(0);

        try {
            const formData = new FormData();
            formData.append('project_id', currentProjectId);
            formData.append('proposal_id', proposalId);
            formData.append('remarks', remarks);
            formData.append('usr_id', collectorUserId);
            formData.append('document', finalDocument);

            const response = await apiService.postTrackingCollector(formData);
            if (response.status === 200) {
                setUploadProgress(100);
                setTimeout(() => setShowSuccess(false), 5000);
                await updateTrackingPermission({ role: ROLES.COLLECTOR, is_view: true, is_edit: false, is_complete: false, is_back: false });
                fetchButtonStatus();
            }
        } catch (error) {
            showAlert('Failed to send to Collector. Please check your connection and try again.');
        } finally {
            setSendingToCollector(false);
            setShowProgress(false);
            setUploadProgress(0);
        }
    };

    const handleSendToLAO = async () => {
        const finalDocument = getFinalDocument();
        const finalSelectedUser = selectedLao || (assignLAO?.length > 0 ? assignLAO[0].usr_id || assignLAO[0].id : null);

        setSendingToLAO(true);
        setShowProgress(true);
        setUploadProgress(0);

        try {
            const formData = new FormData();
            formData.append('project_id', currentProjectId);
            formData.append('proposal_id', proposalId);
            formData.append('remarks', remarks || 'Approved');
            formData.append('usr_id', finalSelectedUser);
            if (finalDocument) formData.append('document', finalDocument);

            const response = await apiService.postTrackingLAO(formData);
            if (response?.status === 200) {
                setUploadProgress(100);
                setShowSendToCollectorModal(false);
                setSelectedUser(''); setSelectedLao(''); setRemarks('Approved'); setSelectedDocument(null);
                await updateTrackingPermission({ role: ROLES.LAO, is_view: true, is_edit: false, is_complete: false, is_back: false });
                fetchButtonStatus();
            }
        } catch (error) {
            showAlert('Failed to appoint LAO Officer.');
        } finally {
            setSendingToLAO(false);
            setShowProgress(false);
            setUploadProgress(0);
        }
    };

    const handleSendToSamanvay = async () => {
        const finalDocument = getFinalDocument();
        if (!finalDocument || !selectedUser) return showAlert('Required', 'Please select a user and upload a document');

        setSendingToSamanvay(true);
        setShowProgress(true);
        setUploadProgress(0);

        try {
            const formData = new FormData();
            formData.append('project_id', currentProjectId);
            formData.append('proposal_id', proposalId);
            formData.append('remarks', remarks);
            formData.append('usr_id', selectedUser);
            formData.append('document', finalDocument);

            const response = await apiService.postTrackingSamanvay(formData);
            if (response.status === 200) {
                setUploadProgress(100);
                setShowSendToCollectorModal(false);
                setSelectedUser(''); setRemarks('Approved'); setSelectedDocument(null);
                await updateTrackingPermission({ role: ROLES.SAMANVAY, is_view: true, is_edit: false, is_complete: false, is_back: false });
                fetchButtonStatus();
            }
        } catch (error) {
            showAlert('Failed to send to Samanvay Officer.');
        } finally {
            setSendingToSamanvay(false);
            setShowProgress(false);
            setUploadProgress(0);
        }
    };
     const handleSendToSamanvayFinal = async () => {
        const finalDocument = getFinalDocument();
        if (!finalDocument || !selectedUser) return showAlert('Required', 'Please select a user and upload a document');

        setSendingToSamanvay(true);
        setShowProgress(true);
        setUploadProgress(0);

        try {
            const formData = new FormData();
            formData.append('project_id', currentProjectId);
            formData.append('proposal_id', proposalId);
            formData.append('remarks', remarks);
            formData.append('usr_id', selectedUser);
            formData.append('document', finalDocument);

            const response = await apiService.postTrackingSamanvayFinal(formData);
            if (response.status === 200) {
                setUploadProgress(100);
                setShowSendToCollectorModal(false);
                setSelectedUser(''); setRemarks('Approved'); setSelectedDocument(null);
                await updateTrackingPermission({ role: ROLES.SAMANVAY, is_view: true, is_edit: false, is_complete: false, is_back: false });
                fetchButtonStatus();
            }
        } catch (error) {
            showAlert('Failed to send to Samanvay Officer.');
        } finally {
            setSendingToSamanvay(false);
            setShowProgress(false);
            setUploadProgress(0);
        }
    };

    const handleSendToSurveyor = async () => {
        if (sendToRole === 'Samanvay') await handleSendToSamanvay();
        else if(sendToRole === 'SamanvayFinal') await handleSendToSamanvayFinal();
        else if (sendToRole === 'LAO') await handleSendToLAO();
        else if (sendToRole === 'Collector') {
            if (!selectedUser || !selectedDocument) return showAlert('Required', 'Please select Collector and upload a document');
            try {
                setSendingToCollector(true);
                await handleAssignLAO(selectedLao);
                await handleSendToCollector(selectedUser);
                setShowSendToCollectorModal(false);
                setSelectedUser(''); setSelectedLao(''); setRemarks('Approved'); setSelectedDocument(null);
                fetchButtonStatus();
            } catch (err) { showAlert("Something went wrong."); } finally { setSendingToCollector(false); }
        }
    };

    const handleSendToLAOClick = async () => {
        resetModalState(); setSendToRole('LAO');
        if (!isLaoAssignDisabled) return showConfirm('Confirm', 'You have already sent. Send again?', () => { setShowSendToCollectorModal(true); fetchAssignLAO(); });
        setShowSendToCollectorModal(true);
        await fetchAssignLAO();
        // setButtonDisabled(true);
    };

    const handleSendToSamanvayClick = () => {
        resetModalState();
        if(userRole === ROLES.COLLECTOR){ setSendToRole('SamanvayFinal') }
        if(userRole === ROLES.PROJECT_INCHARGE){ setSendToRole('Samanvay') }
        if (!isSamanvayDisabled) return showConfirm('Confirm', 'You have already sent. Send again?', () => { setShowSendToCollectorModal(true); fetchUsersSamanvay(); });
        setShowSendToCollectorModal(true);
        fetchUsersSamanvay();
    };

     const handleSendToFinalSamanvayClick = () => {
        resetModalState(); setSendToRole('SamanvayFinal');
        if (!isSamanvayFinalDisabled) return showConfirm('Confirm', 'You have already sent. Send again?', () => { setShowSendToCollectorModal(true); fetchUsersSamanvay(); });
        setShowSendToCollectorModal(true);
        fetchUsersSamanvay();
    };

    const resetModalState = () => { setSelectedUser(''); setRemarks('Approved'); setSelectedDocument(null); setUsers([]); };

    const handleAddNew = (loc, idx) => {
        if (!currentProjectId || !proposalId) return showAlert('Project ID or Proposal ID missing!');
        const info = { projectId: currentProjectId, proposalId: proposalId, district: loc?.dist_name || '', taluka: loc?.taluka_name || '', village: loc?.village_name || '' };
        localStorage.setItem('selectedLocationInfo', JSON.stringify(info));
        setActiveAddFormIndex(idx);
        setEditingLandholding(null);
    };

    const handleEdit = (record) => {
        localStorage.setItem('editingLandholding', JSON.stringify(record));
        localStorage.setItem('selectedLocationInfo', JSON.stringify({ district: record.DistrictName || '', taluka: record.TalukaName || '', village: record.VillageName || '' }));
        setSelectedLandId(record.groupNo);
        setEditingLandholding(record);
        setActiveAddFormIndex(null);
    };

    const handleDelete = async (record) => {
        showConfirm(
            'Delete Landholding', 
            `Are you sure you want to delete landholding for ${record.landholdersName || 'this record'}?`, 
            async () => {
                try {
                    if (record.groupNo) {
                        const response = await apiService.deleteLandHolding(record.groupNo);
                        if (response.status !== 200) throw new Error('Failed to delete from server');
                    }
                    
                    setLandholdingData(prev => prev.filter((r) => String(r.groupNo) !== String(record.groupNo)));
                    await fetchLandholdingData();
                    showAlert('Success', 'Landholding deleted successfully!', 'success');
                } catch (err) { 
                    console.error(err);
                    showAlert('Error', 'Failed to delete landholding.', 'error'); 
                }
            }, 
            null, 
            'danger'
        );
    };

    const handleToggleStatus = async (record) => {
        try {
            const newStatus = !record.status;
            if (record.groupNo) {
                const response = await apiService.updateLandHoldingStatus(record.groupNo, { is_active: newStatus });
                if (response.status !== 200) throw new Error('Failed to update status on server');
            }
            const updatedData = landholdingData.map(r => r.groupNo === record.groupNo ? { ...r, status: newStatus } : r);
            setLandholdingData(updatedData);
        } catch (err) {
            console.error('Error updating status:', err);
            showAlert('Failed to update status. Please try again.');
        }
    };

    const handleViewDocument = (file) => {
        if (!file) return;
        setDocumentUrl(URL.createObjectURL(file)); 
        setShowModal(true); 
    };
    
    const handleViewSignedPdf = async () => {
        try {
            const res = await apiService.getSectionFile(currentProjectId, proposalId, "CoveringLettersSection11");
            if (res?.isSignAvailable && res?.data?.[0]?.file_path) { setViewerFile(res.data[0].file_path); setIsViewerOpen(true); }
        } catch (error) { alert("Unable to open signed document"); }
    };
    const handleCoveringLetterClick = () => {
        onNavigateWithModal('CoveringLetters', { selectedUser, userId: selectedLao, remarks, sendToRole, selectedDocumentName: selectedDocument?.name, timestamp: new Date().getTime() });
        setShowSendToCollectorModal(false); setSubComponent(null);
    };

    useEffect(() => {
        if (shouldRestoreModal && modalParams) {
            setShowSendToCollectorModal(true); fetchUsersSamanvay();
            pendingRestore.current = { user: modalParams.selectedUser || '', lao: modalParams.selectedLao || '', remarks: modalParams.remarks || '' };
            setRemarks(modalParams.remarks || ''); setSendToRole(modalParams.sendToRole || 'Collector');
            setShouldRestoreModal(false);
        }
    }, [shouldRestoreModal, modalParams]);

    useEffect(() => {
        if (pendingRestore.current && (users.length > 0 || laoUsers.length > 0)) {
            setSelectedUser(pendingRestore.current.user); setSelectedLao(pendingRestore.current.lao); setRemarks(pendingRestore.current.remarks);
            pendingRestore.current = null;
        }
    }, [users, laoUsers]);

    // Component Handlers
    const handleSearch = (e) => setSearchTerm(e.target.value);
    const handleDownload = () => setDownloadModalOpen(true);
    const handleReport = () => {
        localStorage.setItem('selectedLocationInfo', JSON.stringify({ projectId: currentProjectId, district: '', taluka: '', village: '' }));
        setSubComponent('ReportLandAcquisition');
    };
    
    const handleParishist = () => { setSelectedComponent("LandholdingList"); setSubComponent('Parishtisht1Notice'); };
    const handleAnusuchi2 = () => { setSelectedComponent("LandholdingList"); setSubComponent('Anusuchi2'); };
    const handleAnusuchi3 = () => { setSelectedComponent("LandholdingList"); setSubComponent('Anusuchi3'); };
    const handleAnusuchi4 = () => { setSelectedComponent("LandholdingList"); setSubComponent('Anusuchi4'); };
    const handleAnusuchi5 = () => { setSelectedComponent("LandholdingList"); setSubComponent('Anusuchi5'); };
    const handleParishtisht6Notice = () => { setSelectedComponent("LandholdingList"); setSubComponent('Parishtisht6Notice'); };
    const handleAnusuchi7 = () => { setSelectedComponent("LandholdingList"); setSubComponent('Anusuchi7'); };
    const handleDocument = () => { setSelectedComponent("LandholdingList"); setSubComponent('OtherDocuments'); };
    const handleAllDocument = () => { setSelectedComponent("LandholdingList"); setSubComponent('LandholdingAllDocu'); };
    const handleProposalDocument = () => { setSelectedComponent("LandholdingList"); setSubComponent('ViewProposalDocument'); };
    const handleEditProposalClick = () => setEditProposalMode(true);
    const handleBackFromEditProposal = () => { setEditProposalMode(false); fetchLandholdingData(); };

    // Download Logic
    const getColumnsForDownload = () => [
        { header: 'S.No.', value: 'index' }, { header: 'Land No', value: 'groupNo' }, { header: 'Landholders Name', value: 'landholdersName' },
        { header: 'Village Name', value: 'VillageName' }, { header: 'Survey No', value: 'SurveyNO' }, { header: 'Total Area', value: 'totalArea' },
        { header: 'Acquired Area', value: 'AquiredArea' }, { header: 'Area Unit', value: 'unit_name' }
    ];
    const getDataForDownload = () => filteredData.map((lh, index) => ({ ...lh, index: index + 1 }));

    const filteredData = landholdingData.filter(record => {
        const search = searchTerm.toLowerCase();
        return String(record.groupNo || '').toLowerCase().includes(search) || String(record.landholdersName || '').toLowerCase().includes(search) ||
            String(record.SurveyNO || '').toLowerCase().includes(search) || String(record.VillageName || '').toLowerCase().includes(search);
    });

    const shouldShowButton = (buttonName) => {
        if (!userRole) return false;
        const perms = { '15': ['appendix1', 'appendix2', 'appendix5', 'appendix6', 'appendix7'], '6': ['all'], '18': ['all'], '3': ['all'], '14': ['all'] };
        return perms[String(userRole).trim()]?.includes('all') || perms[String(userRole).trim()]?.includes(buttonName.toLowerCase());
    };

    const ProgressBar = ({ progress, isVisible }) => isVisible && (
        <div className="w-full bg-gray-200 rounded-full h-2 mb-4">
            <div className="bg-blue-600 h-2 rounded-full transition-all duration-500 ease-out" style={{ width: `${progress}%` }} />
            <div className="flex justify-between text-xs text-gray-500 mt-1"><span>{translations[language].saving}</span><span>{progress}%</span></div>
        </div>
    );

    const toggleRow = (id) => setExpandedRow(expandedRow === id ? null : id);
    const truncateName = (name, max = 15) => name?.length > max ? name.substring(0, max) + '...' : name || '';

    if (editProposalMode && proposalId) {
        return <EditProposal proposalId={proposalId} projectId={currentProjectId} projectName={selectedProject?.project_name} onBack={handleBackFromEditProposal} />;
    }

    const ACTION_BTN = "w-full sm:w-auto justify-center px-4 py-2.5 sm:px-5 sm:py-3 text-sm bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-xl flex items-center space-x-2 shadow-lg disabled:opacity-50 disabled:cursor-not-allowed disabled:grayscale transition-colors";
    const WORKFLOW_BTN = "w-full sm:w-auto justify-center flex items-center px-4 py-2.5 sm:px-5 sm:py-2.5 rounded-xl text-sm font-medium shadow-md disabled:opacity-50 disabled:cursor-not-allowed disabled:grayscale transition-colors";

    return (
        <div className="p-4">
            {/* Top Action Buttons */}
            <div className="mb-6 w-full">
                <div className="flex flex-col lg:flex-row justify-between items-stretch lg:items-center gap-4 lg:gap-6 w-full">
                    <div className="flex flex-wrap gap-3 flex-1">
                        {(userRole !== ROLES.LAO && userRole !== ROLES.SAMANVAY && userRole !== ROLES.COLLECTOR) && shouldShowButton('appendix1') && (
                            <button onClick={() => handleParishist()} disabled={landholdingData.length === 0} className={ACTION_BTN}>
                                <FileText className="h-5 w-5 shrink-0" /><span className="font-medium">{translations[language].appendix1}</span>
                            </button>
                        )}
                        {(userRole !== ROLES.LAO && userRole !== ROLES.SAMANVAY && userRole !== ROLES.COLLECTOR) && shouldShowButton('appendix2') && (
                            <button onClick={() => handleAnusuchi2()} disabled={landholdingData.length === 0} className={ACTION_BTN}>
                                <FileText className="h-5 w-5 shrink-0" /><span className="font-medium">{translations[language].appendix2}</span>
                            </button>
                        )}
                        {(userRole !== ROLES.LAO && userRole !== ROLES.SAMANVAY && userRole !== ROLES.COLLECTOR) && shouldShowButton('appendix3') && (
                            <button onClick={() => handleAnusuchi3()} disabled={landholdingData.length === 0} className={ACTION_BTN}>
                                <FileText className="h-5 w-5 shrink-0" /><span className="font-medium">{translations[language].appendix3}</span>
                            </button>
                        )}
                        {/* {userRole !== ROLES.LAO && shouldShowButton('appendix4') && ( */}
                            <button onClick={() => handleAnusuchi4()} disabled={landholdingData.length === 0} className={ACTION_BTN}>
                                <FileText className="h-5 w-5 shrink-0" /><span className="font-medium">{translations[language].Anusuchi4}</span>
                            </button>
                        {/* )} */}
                        {/* {userRole !== ROLES.LAO && shouldShowButton('appendix5') && ( */}
                            <button onClick={() => handleAnusuchi5()} disabled={landholdingData.length === 0} className={ACTION_BTN}>
                                <FileText className="h-5 w-5 shrink-0" /><span className="font-medium">{translations[language].Anusuchi5}</span>
                            </button>
                        {/* )} */}
                        {(userRole !== ROLES.LAO && userRole !== ROLES.SAMANVAY && userRole !== ROLES.COLLECTOR) && shouldShowButton('appendix6') && (
                            <button onClick={() => handleParishtisht6Notice()} disabled={landholdingData.length === 0} className={ACTION_BTN}>
                                <FileText className="h-5 w-5 shrink-0" /><span className="font-medium">{translations[language].appendix6}</span>
                            </button>
                        )}
                        {/* {userRole !== ROLES.LAO && shouldShowButton('appendix7') && ( */}
                            <button onClick={() => handleAnusuchi7()} disabled={landholdingData.length === 0} className={ACTION_BTN}>
                                <FileText className="h-5 w-5 shrink-0" /><span className="font-medium">{translations[language].Anusuchi7}</span>
                            </button>
                        {/* )} */}
                        {[ROLES.SAMANVAY, ROLES.COLLECTOR, ROLES.LAO].includes(userRole) && (
                            <button onClick={() => handleProposalDocument()} disabled={landholdingData.length === 0} className={ACTION_BTN}>
                                <FileText className="h-5 w-5 shrink-0" /><span className="font-medium">{translations[language].AllDocuments}</span>
                            </button>
                        )}
                        {[ROLES.SAMANVAY, ROLES.COLLECTOR].includes(userRole) && ['Collector', 'LAO'].includes(sendToRole) && (
                            <button onClick={handleCoveringLetterClick} className="w-full sm:w-auto justify-center px-4 py-2.5 sm:px-5 sm:py-3 text-sm bg-blue-500 text-white rounded-xl shadow-lg flex items-center">भूसंपादन अधिकारी नियुक्ती</button>
                        )}
                        {(userRole !== ROLES.LAO && userRole !== ROLES.SAMANVAY && userRole !== ROLES.COLLECTOR) && shouldShowButton('otherdocuments') && (
                            <button onClick={() => handleDocument()} disabled={landholdingData.length === 0} className={ACTION_BTN}>
                                <FileText className="h-5 w-5 shrink-0" /><span className="font-medium">{translations[language].OtherDocuments}</span>
                            </button>
                        )}
                        {(userRole !== ROLES.LAO && userRole !== ROLES.SAMANVAY && userRole !== ROLES.COLLECTOR) && (
                            <button onClick={handleEditProposalClick} disabled={!proposalId || buttonDisabled} className={`w-full sm:w-auto justify-center flex items-center gap-2 px-4 py-2.5 rounded-xl shadow-sm disabled:opacity-50 disabled:cursor-not-allowed transition-colors ${!isSamanvayDisabled ? 'bg-red-600 text-white' : 'bg-amber-600 text-white'}`}>
                                {loading ? <><Loader2 className="h-4 w-4 animate-spin shrink-0" /><span>Processing...</span></> : <><Edit2 className="h-4 w-4 shrink-0" /><span>{translations[language].namunaK}</span></>}
                            </button>
                        )}
                        {[ROLES.PROJECT_INCHARGE, ROLES.DATA_ENTRY].includes(userRole) && (
                            <button onClick={() => handleAllDocument()} disabled={landholdingData.length === 0} className={ACTION_BTN}>
                                <FileText className="h-5 w-5 shrink-0" /><span className="font-medium">{translations[language].AllDocuments}</span>
                            </button>
                        )}
                    </div>

                    {/* Workflow Actions */}
                    {[ROLES.PROJECT_INCHARGE, ROLES.SAMANVAY, ROLES.COLLECTOR].includes(userRole) && (
                        <div className="flex flex-col sm:flex-row sm:flex-wrap items-stretch sm:items-center gap-3 p-3 w-full lg:w-auto lg:ml-auto border border-purple-200 bg-purple-50 rounded-2xl shadow-sm">
                            {userRole === ROLES.PROJECT_INCHARGE && (
                                <button onClick={handleSendToSamanvayClick} disabled={loading || sendingToSamanvay} className={`${WORKFLOW_BTN} ${!isSamanvayDisabled ? "bg-red-600 text-white hover:bg-red-700" : "bg-purple-600 text-white hover:bg-purple-700"}`}>
                                    {sendingToSamanvay ? <><Loader2 className="mr-2 h-4 w-4 animate-spin shrink-0" />{translations[language]?.Sending}</> : <span>{translations[language]?.SendToSamanvayOfficer}</span>}
                                </button>
                            )}
                            {userRole === ROLES.SAMANVAY && (
                                <>
                                    <button onClick={() => { if (!isCollectorDisabled) { showConfirm('Confirm', 'Already sent. Send again?', () => { setSendToRole('Collector'); setShowSendToCollectorModal(true); fetchUsersCollector(); }); return; } setSendToRole('Collector'); setShowSendToCollectorModal(true); fetchUsersCollector(); }} disabled={loading || sendingToCollector || !isCollectorDisabled} className={`${WORKFLOW_BTN} ${!isCollectorDisabled ? 'bg-red-600 text-white' : 'bg-purple-600 text-white'}`}>
                                        {sendingToCollector ? <><Loader2 className="mr-2 h-4 w-4 animate-spin shrink-0" />{translations[language]?.Sending}</> : <span>{translations[language]?.SendToCollector}</span>}
                                    </button>

                                    {/* NEW: Samanvay can assign LAO */}
                                    <button onClick={handleSendToLAOClick} disabled={loading || !isLaoAssignDisabled} className={`${WORKFLOW_BTN} ${!isLaoAssignDisabled ? 'bg-red-600 text-white' : 'bg-purple-600 text-white'}`}>
                                        {sendingToLAO ? <><Loader2 className="mr-2 h-4 w-4 animate-spin shrink-0" />{translations[language]?.Assigning || 'Assigning...'}</> : <span>{translations[language]?.AssignLAOOfficer || 'Assign LAO Officer'}</span>}
                                    </button>

                                    <button onClick={() => setShowBackToProjectInchargeModal(true)} disabled={loading || !isBackToProjectIncharge} className={`${WORKFLOW_BTN} bg-orange-600 text-white`}>
                                        <span>{translations[language]?.BackToProjectIncharge}</span>
                                    </button>
                                </>
                            )}
                            {userRole === ROLES.COLLECTOR && (
                                <>
                                    {/* CHANGED: Collector sends to Samanvay */}
                                    <button onClick={handleSendToFinalSamanvayClick} disabled={loading || !isSamanvayFinalDisabled} className={`${WORKFLOW_BTN} ${!isSamanvayFinalDisabled ? 'bg-red-600 text-white' : 'bg-purple-600 text-white'}`}>
                                        {sendingToSamanvay ? <><Loader2 className="mr-2 h-4 w-4 animate-spin shrink-0" />{translations[language]?.Sending}</> : <span>{translations[language]?.SendToSamanvayOfficer || 'Send to Samanvay Officer'}</span>}
                                    </button>

                                    <button onClick={() => setShowBackToSamanvayModal(true)} disabled={loading || !isSamanvayBackDisabled} className={`${WORKFLOW_BTN} bg-orange-600 text-white`}>
                                        <span>Back to Samanvay</span>
                                    </button>
                                </>
                            )}
                        </div>
                    )}
                </div>
            </div>

            {/* Proposal Locations List & Village-Wise Tables */}
            {[ROLES.PROJECT_INCHARGE, ROLES.DATA_ENTRY].includes(userRole) && (
                <div className="mb-6 bg-gray-50/50 backdrop-blur-sm border border-gray-200 rounded-lg p-6">
                    <div className="mb-6 flex flex-col sm:flex-row justify-between items-end gap-4">
                        <div className="flex-1 w-full max-w-xl">
                            <label className="block text-sm font-medium text-gray-700 mb-2">{translations[language].search}</label>
                            <div className="relative">
                                <input type="text" placeholder={translations[language].SearchPlaceholder || "Search landholdings..."} value={searchTerm} onChange={handleSearch} className="w-full pl-12 pr-12 py-2 rounded-2xl bg-white border-2 border-gray-200 focus:border-blue-500 focus:ring-4 focus:ring-blue-100 text-sm" />
                                <Search className="absolute left-4 top-2.5 h-4 w-4 text-gray-400" />
                                {searchTerm && <button onClick={() => setSearchTerm('')} className="absolute right-4 top-2.5 text-gray-400 hover:text-red-500"><X className="h-4 w-4" /></button>}
                            </div>
                        </div>
                        {/* <div className="flex gap-2 w-full sm:w-auto">
                            <button onClick={handleDownload} className="flex-1 sm:flex-none px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-xl hover:bg-gray-50 flex items-center justify-center gap-2 shadow-sm"><Download className="h-4 w-4"/> Download</button>
                            <button onClick={handleReport} className="flex-1 sm:flex-none px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-xl hover:bg-gray-50 flex items-center justify-center gap-2 shadow-sm"><FileText className="h-4 w-4"/> Report</button>
                        </div> */}
                    </div>

                    <div className="space-y-6">
                        {loading ? (
                            <div className="flex justify-center p-8"><Loader2 className="h-8 w-8 animate-spin text-purple-500" /></div>
                        ) : (
                            proposalLocations.map((loc, idx) => {
                                // Filter data specifically for this village using robust string matching
                                const villageRecords = filteredData.filter(r => 
                                    String(r.DistrictName || '').trim().toLowerCase() === String(loc.dist_name || '').trim().toLowerCase() && 
                                    String(r.TalukaName || '').trim().toLowerCase() === String(loc.taluka_name || '').trim().toLowerCase() && 
                                    String(r.VillageName || '').trim().toLowerCase() === String(loc.village_name || '').trim().toLowerCase()
                                );

                                return (
                                    <div key={idx} className="bg-white border border-gray-200 rounded-lg shadow-sm overflow-hidden">
                                        
                                        {/* Village Header */}
                                        <div className="flex flex-col sm:flex-row sm:items-center justify-between p-4 bg-gray-50 border-b border-gray-200">
                                            <div className="flex flex-wrap gap-4 sm:gap-8 mb-4 sm:mb-0">
                                                <div className="flex flex-col"><span className="text-xs text-gray-500 uppercase">{translations[language].District}</span><span className="font-semibold">{loc.dist_name}</span></div>
                                                <div className="flex flex-col"><span className="text-xs text-gray-500 uppercase">{translations[language].taluka}</span><span className="font-semibold">{loc.taluka_name}</span></div>
                                                <div className="flex flex-col"><span className="text-xs text-gray-500 uppercase">{translations[language].village}</span><span className="font-semibold">{loc.village_name}</span></div>
                                            </div>

                                            {[18, 14].includes(userRole) && (
                                                <button onClick={() => handleAddNew(loc, idx)} disabled={!isSamanvayDisabled} className="px-4 py-2 text-sm rounded-lg flex items-center gap-2 bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50">
                                                    <Plus className="h-4 w-4" /><span>{translations[language].AddLandholding}</span>
                                                </button>
                                            )}
                                        </div>

                                        {/* Dynamic Add Form for this specific village block */}
                                        {activeAddFormIndex === idx && (
                                            <div className="bg-white p-4 border-b border-gray-200 shadow-inner">
                                                <AddLandholdingList
                                                    onBack={() => setActiveAddFormIndex(null)}
                                                    onSuccess={() => { setActiveAddFormIndex(null); fetchLandholdingData(); }}
                                                    projectId={currentProjectId}
                                                    proposalId={proposalId}
                                                />
                                            </div>
                                        )}

                                        {/* Dynamic Edit Form for a record matched to this village block */}
                                        {editingLandholding && 
                                         String(editingLandholding.DistrictName || '').trim().toLowerCase() === String(loc.dist_name || '').trim().toLowerCase() &&
                                         String(editingLandholding.TalukaName || '').trim().toLowerCase() === String(loc.taluka_name || '').trim().toLowerCase() &&
                                         String(editingLandholding.VillageName || '').trim().toLowerCase() === String(loc.village_name || '').trim().toLowerCase() && (
                                            <div className="bg-white p-4 border-b border-gray-200 shadow-inner">
                                                <EditLandholdingList
                                                    onBack={() => setEditingLandholding(null)}
                                                    onSuccess={() => { setEditingLandholding(null); fetchLandholdingData(); }}
                                                    LandAcquisition_id={editingLandholding.groupNo}
                                                />
                                            </div>
                                        )}

                                        {/* Village-Specific Landholding Table */}
                                        <div className="p-4">
                                            {villageRecords.length > 0 ? (
                                                <div className="overflow-x-auto rounded border border-gray-200">
                                                    <table className="min-w-full bg-white divide-y divide-gray-200">
                                                        <thead className="bg-blue-50">
                                                            <tr>
                                                                {[18, 14].includes(userRole) && <th className="p-3 text-left text-xs font-medium text-gray-500 uppercase">{translations[language].Action}</th>}
                                                                <th className="p-3 text-left text-xs font-medium text-gray-500 uppercase">{translations[language].LandholdersName}</th>
                                                                <th className="p-3 text-left text-xs font-medium text-gray-500 uppercase">{translations[language].AddSurveyGatNo}</th>
                                                                <th className="p-3 text-left text-xs font-medium text-gray-500 uppercase">{translations[language].TotalArea}</th>
                                                                <th className="p-3 text-left text-xs font-medium text-gray-500 uppercase">{translations[language].AcquiredArea}</th>
                                                                <th className="p-3 text-left text-xs font-medium text-gray-500 uppercase">{translations[language].areaUnit}</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody className="divide-y divide-gray-200">
                                                            {villageRecords.map((record) => (
                                                                <React.Fragment key={record.groupNo}>
                                                                    <tr className="hover:bg-gray-50">
                                                                        {[18, 14].includes(userRole) && (
                                                                            <td className="p-3">
                                                                                <div className="flex space-x-2">
                                                                                    <button 
                                                                                        onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleEdit(record); }} 
                                                                                        disabled={!isSamanvayDisabled}
                                                                                        className="text-blue-500 hover:bg-blue-50 p-2 rounded disabled:opacity-50"
                                                                                    >
                                                                                        <Edit2 size={16} />
                                                                                    </button>
                                                                                    <button 
                                                                                        onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleDelete(record); }} 
                                                                                        disabled={!isSamanvayDisabled}
                                                                                        className="text-red-500 hover:bg-red-50 p-2 rounded disabled:opacity-50"
                                                                                    >
                                                                                        <Trash2 size={16} />
                                                                                    </button>
                                                                                </div>
                                                                            </td>
                                                                        )}
                                                                        <td className="p-3">
                                                                            <div className="flex items-center space-x-2">
                                                                                {record.owners?.length > 0 && (
                                                                                    <button onClick={() => toggleRow(record.groupNo)} className="text-blue-500">
                                                                                        <svg className={`w-4 h-4 transform ${expandedRow === record.groupNo ? 'rotate-180' : ''}`} fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" /></svg>
                                                                                    </button>
                                                                                )}
                                                                                <span title={record.landholdersName}>{truncateName(record.landholdersName)}</span>
                                                                            </div>
                                                                        </td>
                                                                        <td className="p-3 text-gray-700">{record.SurveyNO}</td>
                                                                        <td className="p-3 text-gray-700">{record.totalArea}</td>
                                                                        <td className="p-3 text-gray-700">{record.AquiredArea}</td>
                                                                        <td className="p-3"><span className="px-2.5 py-0.5 rounded-full text-xs bg-blue-100 text-blue-800">{record.unit_name}</span></td>
                                                                    </tr>
                                                                    {expandedRow === record.groupNo && record.owners?.length > 0 && (
                                                                        <tr className="bg-blue-50">
                                                                            <td colSpan={10} className="p-4">
                                                                                <div className="border border-blue-200 rounded-lg overflow-hidden shadow-sm">
                                                                                    <table className="min-w-full divide-y divide-blue-200">
                                                                                        <thead className="bg-blue-100">
                                                                                            <tr>
                                                                                                <th className="p-2 pl-4 text-left text-xs font-semibold text-blue-800 uppercase tracking-wider">{translations[language].LandNo}</th>
                                                                                                <th className="p-2 text-left text-xs font-semibold text-blue-800 uppercase tracking-wider">{translations[language].ownerName}</th>
                                                                                                <th className="p-2 text-left text-xs font-semibold text-blue-800 uppercase tracking-wider">{translations[language].DistrictName}</th>
                                                                                                <th className="p-2 text-left text-xs font-semibold text-blue-800 uppercase tracking-wider">{translations[language].TalukaName}</th>
                                                                                                <th className="p-2 text-left text-xs font-semibold text-blue-800 uppercase tracking-wider">{translations[language].VillageName}</th>
                                                                                                <th className="p-2 text-left text-xs font-semibold text-blue-800 uppercase tracking-wider">{translations[language].SurveyNo}</th>
                                                                                                <th className="p-2 text-left text-xs font-semibold text-blue-800 uppercase tracking-wider">{translations[language].TotalArea}</th>
                                                                                                <th className="p-2 text-left text-xs font-semibold text-blue-800 uppercase tracking-wider">{translations[language].AcquiredArea}</th>
                                                                                                <th className="p-2 pr-4 text-left text-xs font-semibold text-blue-800 uppercase tracking-wider">{translations[language].areaUnit}</th>
                                                                                            </tr>
                                                                                        </thead>
                                                                                        <tbody className="divide-y divide-blue-100 bg-white">
                                                                                            {record.owners.map((owner, ownerIndex) => (
                                                                                                <tr key={owner.land_owner_id} className={`hover:bg-blue-50 transition-colors duration-150 ${ownerIndex % 2 === 0 ? 'bg-blue-25' : 'bg-white'}`}>
                                                                                                    <td className="p-2 pl-4 text-sm text-gray-700 font-medium">{owner.LandAcquisition_id}</td>
                                                                                                    <td className="p-2 text-sm text-gray-900 font-medium" title={owner.owner_name}>{truncateName(owner.owner_name, 20)}</td>
                                                                                                    <td className="p-2 text-sm text-gray-600">{owner.dist_name}</td>
                                                                                                    <td className="p-2 text-sm text-gray-600">{owner.taluka_name}</td>
                                                                                                    <td className="p-2 text-sm text-gray-600">{owner.village_name}</td>
                                                                                                    <td className="p-2 text-sm text-gray-600">{owner.survey_no}</td>
                                                                                                    <td className="p-2 text-sm text-gray-800 font-medium">{owner.owner_total_area}</td>
                                                                                                    <td className="p-2 text-sm text-gray-800 font-medium">{owner.owner_aqr_area}</td>
                                                                                                    <td className="p-2 pr-4">
                                                                                                        <span className="inline-flex items-center px-2 py-1 rounded-full text-[10px] font-medium bg-blue-100 text-blue-800">
                                                                                                            {record.unit_name}
                                                                                                        </span>
                                                                                                    </td>
                                                                                                </tr>
                                                                                            ))}
                                                                                        </tbody>
                                                                                    </table>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    )}
                                                                </React.Fragment>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            ) : (
                                                <div className="text-center py-6 text-gray-500">
                                                    <p>No landholdings added for {loc.village_name} yet.</p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                );
                            })
                        )}

                        {/* Fallback for unmapped records (if legacy data has mismatching loc strings) */}
                        {!loading && (() => {
                            const mappedIds = new Set();
                            proposalLocations.forEach(loc => {
                                filteredData.forEach(r => {
                                    if (String(r.DistrictName).trim().toLowerCase() === String(loc.dist_name).trim().toLowerCase() && 
                                        String(r.TalukaName).trim().toLowerCase() === String(loc.taluka_name).trim().toLowerCase() && 
                                        String(r.VillageName).trim().toLowerCase() === String(loc.village_name).trim().toLowerCase()) {
                                        mappedIds.add(r.groupNo);
                                    }
                                });
                            });
                            
                            const unmappedRecords = filteredData.filter(r => !mappedIds.has(r.groupNo));
                            if (unmappedRecords.length === 0) return null;

                            const isUnmappedEditing = editingLandholding && unmappedRecords.some(r => r.groupNo === editingLandholding.groupNo);

                            return (
                                <div className="mt-8 bg-white border border-red-200 rounded-lg shadow-sm overflow-hidden">
                                    <div className="bg-red-50 p-4 border-b border-red-200">
                                        <h3 className="text-red-800 font-semibold">Other / Unmapped Landholdings</h3>
                                        <p className="text-xs text-red-600 mt-1">These legacy records do not exactly match the District/Taluka/Village strings mapped to the current proposal.</p>
                                    </div>

                                    {isUnmappedEditing && (
                                        <div className="bg-white p-4 border-b border-red-200 shadow-inner">
                                            <EditLandholdingList
                                                onBack={() => setEditingLandholding(null)}
                                                onSuccess={() => { setEditingLandholding(null); fetchLandholdingData(); }}
                                                LandAcquisition_id={editingLandholding.groupNo}
                                            />
                                        </div>
                                    )}

                                    <div className="p-4">
                                        <div className="overflow-x-auto rounded border border-gray-200">
                                            <table className="min-w-full bg-white divide-y divide-gray-200">
                                                <thead className="bg-red-50">
                                                    <tr>
                                                        {[18, 14].includes(userRole) && <th className="p-3 text-left text-xs font-medium text-gray-500 uppercase">{translations[language].Action}</th>}
                                                        <th className="p-3 text-left text-xs font-medium text-gray-500 uppercase">District</th>
                                                        <th className="p-3 text-left text-xs font-medium text-gray-500 uppercase">Taluka</th>
                                                        <th className="p-3 text-left text-xs font-medium text-gray-500 uppercase">Village</th>
                                                        <th className="p-3 text-left text-xs font-medium text-gray-500 uppercase">{translations[language].LandholdersName}</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="divide-y divide-gray-200">
                                                    {unmappedRecords.map((record) => (
                                                        <React.Fragment key={record.groupNo}>
                                                            <tr className="hover:bg-gray-50">
                                                                {[18, 14].includes(userRole) && (
                                                                    <td className="p-3">
                                                                        <div className="flex space-x-2">
                                                                            <button 
                                                                                onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleEdit(record); }} 
                                                                                className="text-blue-500 hover:bg-blue-50 p-2 rounded"
                                                                            >
                                                                                <Edit2 size={16} />
                                                                            </button>
                                                                            <button 
                                                                                onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleDelete(record); }} 
                                                                                className="text-red-500 hover:bg-red-50 p-2 rounded"
                                                                            >
                                                                                <Trash2 size={16} />
                                                                            </button>
                                                                        </div>
                                                                    </td>
                                                                )}
                                                                <td className="p-3 text-gray-700">{record.DistrictName}</td>
                                                                <td className="p-3 text-gray-700">{record.TalukaName}</td>
                                                                <td className="p-3 text-gray-700">{record.VillageName}</td>
                                                                <td className="p-3 text-gray-700">
                                                                    <div className="flex items-center space-x-2">
                                                                        {record.owners?.length > 0 && (
                                                                            <button onClick={() => toggleRow(record.groupNo)} className="text-blue-500">
                                                                                <svg className={`w-4 h-4 transform ${expandedRow === record.groupNo ? 'rotate-180' : ''}`} fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" /></svg>
                                                                            </button>
                                                                        )}
                                                                        <span title={record.landholdersName}>{truncateName(record.landholdersName)}</span>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                            {expandedRow === record.groupNo && record.owners?.length > 0 && (
                                                                <tr className="bg-red-50/50">
                                                                    <td colSpan={10} className="p-4">
                                                                        <div className="border border-red-200 rounded-lg overflow-hidden shadow-sm">
                                                                            <table className="min-w-full divide-y divide-red-200">
                                                                                <thead className="bg-red-100">
                                                                                    <tr>
                                                                                        <th className="p-2 pl-4 text-left text-xs font-semibold text-red-800 uppercase tracking-wider">{translations[language].LandNo}</th>
                                                                                        <th className="p-2 text-left text-xs font-semibold text-red-800 uppercase tracking-wider">{translations[language].ownerName}</th>
                                                                                        <th className="p-2 text-left text-xs font-semibold text-red-800 uppercase tracking-wider">{translations[language].SurveyNo}</th>
                                                                                        <th className="p-2 text-left text-xs font-semibold text-red-800 uppercase tracking-wider">{translations[language].TotalArea}</th>
                                                                                        <th className="p-2 text-left text-xs font-semibold text-red-800 uppercase tracking-wider">{translations[language].AcquiredArea}</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody className="divide-y divide-red-100 bg-white">
                                                                                    {record.owners.map(owner => (
                                                                                        <tr key={owner.land_owner_id}>
                                                                                            <td className="p-2 pl-4 text-sm text-gray-700">{owner.LandAcquisition_id}</td>
                                                                                            <td className="p-2 text-sm text-gray-900">{truncateName(owner.owner_name, 20)}</td>
                                                                                            <td className="p-2 text-sm text-gray-600">{owner.survey_no}</td>
                                                                                            <td className="p-2 text-sm text-gray-800">{owner.owner_total_area}</td>
                                                                                            <td className="p-2 text-sm text-gray-800">{owner.owner_aqr_area}</td>
                                                                                        </tr>
                                                                                    ))}
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </React.Fragment>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            );
                        })()}
                    </div>
                </div>
            )}

            {/* Modals */}
            <DownloadModal isOpen={downloadModalOpen} onClose={() => setDownloadModalOpen(false)} title={translations[language].LandholdingManagement} data={getDataForDownload()} columns={getColumnsForDownload()} isLoading={downloadLoading} setIsLoading={setDownloadLoading} screenName="Landholding Management" />

            {showAlertModal && (
                <div className="fixed top-4 right-4 z-50">
                    <div className={`bg-white rounded-lg shadow-lg border-l-4 p-4 max-w-sm ${alertConfig.type === 'error' ? 'border-red-500' : 'border-green-500'}`}>
                        <div className="flex justify-between items-start">
                            <div><h3 className="text-sm font-medium">{alertConfig.title}</h3><p className="text-sm text-gray-600">{alertConfig.message}</p></div>
                            <button onClick={() => setShowAlertModal(false)}><X className="h-4 w-4" /></button>
                        </div>
                    </div>
                </div>
            )}

            {showSendToCollectorModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto">
                        <div className="p-6">
                            {/* <h3 className="text-lg font-semibold mb-4">Send Document</h3> */}
                            <div className="space-y-4">
                                {sendToRole === 'Collector' && (
                                    <div>
                                        <label className="block text-sm mb-2">{translations[language]?.SelectCollector || 'Select Collector'}</label>
                                        <select value={selectedUser} onChange={(e) => setSelectedUser(e.target.value)} className="w-full p-2 border rounded">
                                            <option value="">{translations[language]?.SelectCollector || 'Select Collector'}</option>
                                            {users.map(u => <option key={u.id || u.usr_id} value={u.id || u.usr_id}>{u.full_name || u.user_name}</option>)}
                                        </select>
                                    </div>
                                )}
                                {sendToRole === 'LAO' && (
                                    <div>
                                        <label className="block text-sm mb-2">{translations[language]?.SelectLAOOfficer || 'Select LAO Officer'}</label>
                                        <select value={selectedLao} onChange={(e) => setSelectedLao(e.target.value)} className="w-full p-2 border rounded">
                                            <option value="">{translations[language]?.SelectLAOOfficer || 'Select LAO Officer'}</option>
                                            {assignLAO && Array.isArray(assignLAO) && assignLAO.map((u) => <option key={u.usr_id || u.id} value={u.usr_id || u.id}>{u.full_name || u.user_name}</option>)}
                                            {laoUsers && Array.isArray(laoUsers) && laoUsers.filter(lao => !assignLAO?.some(assigned => (assigned.usr_id || assigned.id) === (lao.usr_id || lao.id))).map(u => <option key={u.usr_id || u.id} value={u.usr_id || u.id}>{u.full_name || u.user_name}</option>)}
                                        </select>
                                    </div>
                                )}
                                {sendToRole === 'Samanvay' && (
                                    <div>
                                        <label className="block text-sm mb-2">{translations[language]?.SelectSamanvayOfficer || 'Select Samanvay Officer'}</label>
                                        <select value={selectedUser} onChange={(e) => setSelectedUser(e.target.value)} className="w-full p-2 border rounded">
                                            <option value="">{translations[language]?.SelectSamanvayOfficer || 'Select Samanvay Officer'}</option>
                                            {users.map(u => <option key={u.id || u.usr_id} value={u.id || u.usr_id}>{u.full_name || u.user_name}</option>)}
                                        </select>
                                    </div>
                                )}
                                 {sendToRole === 'SamanvayFinal' && (
                                    <div>
                                        <label className="block text-sm mb-2">{translations[language]?.SelectSamanvayOfficer || 'Select Samanvay Officer'}</label>
                                        <select value={selectedUser} onChange={(e) => setSelectedUser(e.target.value)} className="w-full p-2 border rounded">
                                            <option value="">{translations[language]?.SelectSamanvayOfficer || 'Select Samanvay Officer'}</option>
                                            {users.map(u => <option key={u.id || u.usr_id} value={u.id || u.usr_id}>{u.full_name || u.user_name}</option>)}
                                        </select>
                                    </div>
                                )}
                                <div>
                                    <label className="block text-sm mb-2">{translations[language]?.Remarks || 'Remarks'}</label>
                                    <textarea value={remarks} onChange={e => setRemarks(e.target.value)} rows={3} className="w-full p-2 border rounded" />
                                </div>
                                {([ROLES.COLLECTOR, ROLES.PROJECT_INCHARGE, ROLES.SAMANVAY].includes(userRole)) && (
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            {translations[language]?.UploadDocument || 'Upload Document'} *
                                        </label>
                                        <input
                                            type="file"
                                            onChange={e => setSelectedDocument(e.target.files[0])}
                                            className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
                                            accept=".pdf,.doc,.docx,.jpg,.png"
                                        />
                                        {selectedDocument && (
                                            <div className="mt-2 p-3 bg-green-50 rounded-lg border border-green-200">
                                                <div className="flex items-center justify-between mb-2">
                                                    <p className="text-sm text-green-700 font-medium truncate max-w-[60%]">
                                                        {translations[language]?.Selected || 'Selected'}: {selectedDocument.name}
                                                    </p>
                                                    <span className="text-xs text-green-600 bg-green-100 px-2 py-1 rounded-full">
                                                        {(selectedDocument.size / 1024 / 1024).toFixed(2)} MB
                                                    </span>
                                                </div>
                                                <div className="flex gap-2">
                                                    {selectedDocument.type === 'application/pdf' && (
                                                        <>
                                                            <button
                                                                type="button"
                                                                onClick={() => {
                                                                    setPdfForSigning(selectedDocument);
                                                                    setShowSignaturePad(true);
                                                                }}
                                                                disabled={uploadStatus === 'uploading'}
                                                                className="px-3 py-1 text-xs bg-purple-600 text-white rounded hover:bg-purple-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center gap-1 transition-colors"
                                                            >
                                                                {uploadStatus === 'uploading' ? (
                                                                    <>
                                                                        <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-white"></div>
                                                                        Signing...
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <svg className="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                                                                        </svg>
                                                                        Sign Doc
                                                                    </>
                                                                )}
                                                            </button>
                                                            <button
                                                                type="button"
                                                                onClick={() => handleViewDocument(uploadStatus === 'success' ? selectedSignDocument : selectedDocument)}
                                                                className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1 transition-colors"
                                                            >
                                                                <Eye className="h-3 w-3" />
                                                                {translations[language]?.View || 'View'}
                                                            </button>
                                                        </>
                                                    )}
                                                </div>
                                                {uploadStatus === 'success' && (
                                                    <div className="mt-2 p-2 bg-green-100 border border-green-300 rounded text-xs text-green-700">
                                                        ✅ Document Signed Successfully
                                                    </div>
                                                )}
                                                {uploadStatus === 'error' && uploadError && (
                                                    <div className="mt-2 p-2 bg-red-100 border border-red-300 rounded text-xs text-red-700">
                                                        ❌ {uploadError}
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                            <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
                                <button onClick={() => setShowSendToCollectorModal(false)} className="px-4 py-2 border rounded hover:bg-gray-50">{translations[language]?.Cancel || 'Cancel'}</button>
                             <button
                                 onClick={handleSendToSurveyor}
                                 disabled={showProgress}
                                 className="px-4 py-2 bg-blue-600 text-white rounded flex items-center"
                                >
                                 {showProgress ? (
                                   <>
                                     <Loader2 className="animate-spin w-4 h-4 mr-2" />
                                     {translations[language].Sending}
                                   </>
                                 ) : (
                                   <>
                                     <Send className="w-4 h-4 mr-2" />
                                     {translations[language].Send}
                                   </>
                                 )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* ---> RESTORED: Document Preview Modal <--- */}
            {showModal && (
                <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-white rounded-xl shadow-2xl w-full max-w-4xl mx-4 max-h-[90vh] overflow-hidden flex flex-col">
                        <div className="flex justify-between items-center p-4 border-b">
                            <h3 className="text-xl font-semibold text-gray-800">{translations[language]?.DocumentPreview || 'Document Preview'}</h3>
                            <button
                                onClick={() => {
                                    setShowModal(false);
                                    if (documentUrl) URL.revokeObjectURL(documentUrl);
                                }}
                                className="text-gray-400 hover:text-gray-700 text-2xl font-bold"
                            >
                                ×
                            </button>
                        </div>
                        <div className="flex-1 p-4 overflow-hidden">
                            <iframe
                                src={documentUrl}
                                className="w-full h-[70vh] rounded border border-gray-300"
                                title="Document Preview"
                            />
                        </div>
                    </div>
                </div>
            )}
            
            {showSignaturePad && pdfForSigning && (
                <SignaturePad pdfFile={pdfForSigning} onSign={(sigs) => { setShowSignaturePad(false); signDocument(pdfForSigning, sigs).then(() => setPdfForSigning(null)); }} onCancel={() => { setShowSignaturePad(false); setPdfForSigning(null); }} />
            )}

            {isViewerOpen && viewerFile && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
                    <div className="bg-white rounded-lg w-[80%] max-w-6xl h-[80%] relative">
                        <div className="flex justify-between p-4 border-b">
                            <h3 className="text-lg font-semibold">Signed Document</h3>
                            <button onClick={() => setIsViewerOpen(false)}>✕</button>
                        </div>
                        <iframe src={viewerFile} className="w-full h-full" title="PDF viewer" />
                    </div>
                </div>
            )}

            {showConfirmModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg shadow-lg w-full max-w-sm mx-4">
                        <div className="p-6">
                            <div className={`w-12 h-12 rounded-full mx-auto mb-4 flex items-center justify-center ${confirmConfig.type === 'danger' ? 'bg-red-100' :
                                confirmConfig.type === 'warning' ? 'bg-yellow-100' :
                                    'bg-blue-100'
                                }`}>
                                {confirmConfig.type === 'danger' ? '⚠' :
                                    confirmConfig.type === 'warning' ? '⚠' : '?'}
                            </div>
                            <h3 className="text-lg font-semibold text-gray-900 mb-2 text-center">
                                {confirmConfig.title}
                            </h3>
                            <p className="text-gray-600 text-sm mb-6 text-center">
                                {confirmConfig.message}
                            </p>
                            <div className="flex gap-3">
                                <button
                                    onClick={() => {
                                        if (confirmConfig.onCancel) confirmConfig.onCancel();
                                        setShowConfirmModal(false);
                                    }}
                                    className="flex-1 py-2 px-4 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition-colors"
                                >
                                    {translations[language]?.Cancel || 'Cancel'}
                                </button>
                                <button
                                    onClick={() => {
                                        if (confirmConfig.onConfirm) confirmConfig.onConfirm();
                                        setShowConfirmModal(false);
                                    }}
                                    className={`flex-1 py-2 px-4 text-white rounded-md transition-colors ${confirmConfig.type === 'danger' ? 'bg-red-600 hover:bg-red-700' :
                                        confirmConfig.type === 'warning' ? 'bg-yellow-600 hover:bg-yellow-700' :
                                            'bg-blue-600 hover:bg-blue-700'
                                        }`}
                                >
                                    {translations[language]?.Confirm || 'Confirm'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            
            {userRole === ROLES.SAMANVAY && <SendTrackingModal isOpen={showBackToProjectInchargeModal} onClose={() => setShowBackToProjectInchargeModal(false)} role="BackToProjectIncharge" projectId={currentProjectId} proposalId={proposalId} translations={translations} language={language} onSuccess={async () => { setShowBackToProjectInchargeModal(false); await updateTrackingPermission({ role: ROLES.PROJECT_INCHARGE, is_view: true, is_edit: true, is_complete: false, is_back: true }); fetchLandholdingData(); }} />}
            {userRole === ROLES.COLLECTOR && <SendTrackingModal isOpen={showBackToSamanvayModal} onClose={() => setShowBackToSamanvayModal(false)} role="Back_Samanvay" projectId={currentProjectId} proposalId={proposalId} translations={translations} language={language} onSuccess={async () => { setShowBackToSamanvayModal(false); await updateTrackingPermission({ role: ROLES.SAMANVAY, is_view: true, is_edit: true, is_complete: false, is_back: true }); fetchLandholdingData(); }} />}
        </div>
    );
};

export default LandholdingList;